// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/nucleo-icons.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

 =========================================================
 * Light Bootstrap Dashboard React - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard-react
 * Copyright 2020 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*      light colors         */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*           Font Smoothing      */
body,
h1, .h1,
h2, .h2,
h3, .h3,
h4, .h4,
h5, .h5,
h6, .h6,
p,
.navbar,
.brand,
.btn-simple,
.alert,
a,
.td-name,
td,
button.close {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4 {
  font-weight: 300;
  margin: 30px 0 15px;
}

h1, .h1 {
  font-size: 52px;
}

h2, .h2 {
  font-size: 36px;
}

h3, .h3 {
  font-size: 28px;
  margin: 20px 0 10px;
}

h4, .h4 {
  font-size: 22px;
  line-height: 30px;
}

h5, .h5 {
  font-size: 16px;
  margin-bottom: 15px;
}

h6, .h6 {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

p {
  font-size: 16px;
  line-height: 1.5;
}

h1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {
  color: #9A9A9A;
  font-weight: 300;
  line-height: 1.5;
}

h1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {
  font-size: 60%;
}

h1 .subtitle {
  display: block;
  margin: 0 0 30px;
}

.text-muted {
  color: #9A9A9A;
}

.text-primary, .text-primary:hover {
  color: #1D62F0 !important;
}

.text-info, .text-info:hover {
  color: #1DC7EA !important;
}

.text-success, .text-success:hover {
  color: #87CB16 !important;
}

.text-warning, .text-warning:hover {
  color: #FF9500 !important;
}

.text-danger, .text-danger:hover {
  color: #FF4A55 !important;
}

/*     General overwrite     */
body,
.wrapper {
  min-height: 100vh;
  position: relative;
}

a {
  color: #1DC7EA;
}
a:hover, a:focus {
  color: #42d0ed;
  text-decoration: none;
}

a:focus, a:active,
button::-moz-focus-inner,
input::-moz-focus-inner,
input[type=reset]::-moz-focus-inner,
input[type=button]::-moz-focus-inner,
input[type=submit]::-moz-focus-inner,
select::-moz-focus-inner,
input[type=file] > input[type=button]::-moz-focus-inner {
  outline: 0;
}

.ui-slider-handle:focus,
.navbar-toggle,
input:focus {
  outline: 0 !important;
}

/*           Animations              */
.form-control,
.input-group-addon,
.tagsinput,
.navbar,
.navbar .alert {
  transition: all 300ms linear;
}

.sidebar .nav a,
.table > tbody > tr .td-actions .btn {
  transition: all 150ms ease-in;
}

.btn {
  transition: all 100ms ease-in;
}

.fa, .fas, .far, .fal, .fad, .fab {
  width: 18px;
  text-align: center;
}

.margin-top {
  margin-top: 50px;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}

.page-header .page-header-image {
  background-position: center center;
  background-size: cover;
  overflow: hidden;
  width: 100%;
  z-index: 1;
}
.page-header .title-container {
  color: #fff;
  position: relative;
  top: 250px;
  z-index: 3;
}
.page-header .filter:after {
  background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #9368e9 0%, #943bea 100%) repeat scroll 0 0/150% 150%;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  opacity: 0.77;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

.documentation .page-header,
.documentation .page-header-image,
.documentation .page-header-image .filter:after {
  height: 100vh;
}

.documentation .footer {
  z-index: 3;
}

.documentation .wrapper {
  margin-top: -61px;
  height: 100vh;
}

.documentation .navbar {
  z-index: 21;
}

.sidebar,
body > .navbar-collapse {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 260px;
  display: block;
  z-index: 1;
  color: #fff;
  font-weight: 200;
  background-size: cover;
  background-position: center center;
}
.sidebar .sidebar-wrapper,
body > .navbar-collapse .sidebar-wrapper {
  position: relative;
  max-height: calc(100vh - 75px);
  min-height: 100%;
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 100px;
}
.sidebar .sidebar-background,
body > .navbar-collapse .sidebar-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .logo,
body > .navbar-collapse .logo {
  padding: 10px 15px 9px 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  z-index: 4;
}
.sidebar .logo p,
body > .navbar-collapse .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #FFFFFF;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .simple-text,
body > .navbar-collapse .logo .simple-text {
  text-transform: uppercase;
  padding: 5px 0px;
  display: block;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
  line-height: 30px;
}
.sidebar .logo-tim,
body > .navbar-collapse .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
body > .navbar-collapse .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
body > .navbar-collapse .nav {
  margin-top: 20px;
  float: none;
  display: block;
}
.sidebar .nav li .nav-link,
body > .navbar-collapse .nav li .nav-link {
  color: #FFFFFF;
  margin: 5px 15px;
  opacity: 0.86;
  border-radius: 4px;
  display: block;
  padding: 10px 15px;
}
.sidebar .nav li .nav-link:hover,
body > .navbar-collapse .nav li .nav-link:hover {
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}
.sidebar .nav li .nav-link p,
body > .navbar-collapse .nav li .nav-link p {
  margin: 0;
  line-height: 31px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-flex;
}
.sidebar .nav li .nav-link i,
body > .navbar-collapse .nav li .nav-link i {
  font-size: 28px;
  margin-right: 15px;
  width: 30px;
  text-align: center;
  vertical-align: middle;
  float: left;
}
.sidebar .nav li:hover .nav-link,
body > .navbar-collapse .nav li:hover .nav-link {
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}
.sidebar .nav li.active .nav-link,
body > .navbar-collapse .nav li.active .nav-link {
  color: #FFFFFF;
  opacity: 1;
  background: rgba(255, 255, 255, 0.23);
}
.sidebar .nav li.separator,
body > .navbar-collapse .nav li.separator {
  margin: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.sidebar .nav li.separator + .nav-item,
body > .navbar-collapse .nav li.separator + .nav-item {
  margin-top: 31px;
}
.sidebar .nav .caret,
body > .navbar-collapse .nav .caret {
  margin-top: 13px;
  position: absolute;
  right: 30px;
}
.sidebar .nav .active-pro,
body > .navbar-collapse .nav .active-pro {
  position: absolute;
  width: 100%;
  bottom: 10px;
}
.sidebar .nav .active-pro a,
body > .navbar-collapse .nav .active-pro a {
  color: #FFFFFF !important;
}
.sidebar .nav .nav-link,
body > .navbar-collapse .nav .nav-link {
  color: #FFFFFF;
  margin: 5px 15px;
  opacity: 0.86;
  border-radius: 4px;
  text-transform: uppercase;
  line-height: 30px;
  font-size: 12px;
  font-weight: 600;
}
.sidebar .logo,
body > .navbar-collapse .logo {
  padding: 10px 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.sidebar .logo p,
body > .navbar-collapse .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #FFFFFF;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .simple-text,
body > .navbar-collapse .logo .simple-text {
  text-transform: uppercase;
  padding: 5px 0px;
  display: block;
  font-size: 18px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
  line-height: 30px;
}
.sidebar .logo-tim,
body > .navbar-collapse .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
body > .navbar-collapse .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar:after, .sidebar:before,
body > .navbar-collapse:after,
body > .navbar-collapse:before {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.sidebar:before,
body > .navbar-collapse:before {
  opacity: 0.33;
  background: #000000;
}
.sidebar:after,
body > .navbar-collapse:after {
  background: #9368E9;
  background: linear-gradient(to bottom, #9368E9 0%, #943bea 100%);
  background-size: 150% 150%;
  z-index: 3;
  opacity: 1;
}
.sidebar[data-image]:after, .sidebar.has-image:after,
body > .navbar-collapse[data-image]:after,
body > .navbar-collapse.has-image:after {
  opacity: 0.77;
}
.sidebar[data-color=black]:after,
body > .navbar-collapse[data-color=black]:after {
  background: #777777;
  background: linear-gradient(to bottom, #777777 0%, #777777 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=blue]:after,
body > .navbar-collapse[data-color=blue]:after {
  background: #1F77D0;
  background: linear-gradient(to bottom, #1F77D0 0%, #533ce1 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=azure]:after,
body > .navbar-collapse[data-color=azure]:after {
  background: #1DC7EA;
  background: linear-gradient(to bottom, #1DC7EA 0%, #4091ff 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=green]:after,
body > .navbar-collapse[data-color=green]:after {
  background: #87CB16;
  background: linear-gradient(to bottom, #87CB16 0%, #6dc030 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=orange]:after,
body > .navbar-collapse[data-color=orange]:after {
  background: #FFA534;
  background: linear-gradient(to bottom, #FFA534 0%, #ff5221 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=red]:after,
body > .navbar-collapse[data-color=red]:after {
  background: #FB404B;
  background: linear-gradient(to bottom, #FB404B 0%, #bb0502 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=purple]:after,
body > .navbar-collapse[data-color=purple]:after {
  background: #9368E9;
  background: linear-gradient(to bottom, #9368E9 0%, #943bea 100%);
  background-size: 150% 150%;
}

.main-panel {
  background: rgba(203, 203, 210, 0.15);
  position: relative;
  float: right;
  width: calc(100% - 260px);
  min-height: 100%;
}
.main-panel > .content {
  padding: 30px 15px;
  min-height: calc(100% - 123px);
}
.main-panel > .footer {
  border-top: 1px solid #e7e7e7;
}
.main-panel .navbar {
  margin-bottom: 0;
}

.sidebar,
.main-panel {
  overflow: auto;
  max-height: 100%;
  height: 100%;
  transition-property: top, bottom;
  transition-duration: 0.2s, 0.2s;
  transition-timing-function: linear, linear;
  -webkit-overflow-scrolling: touch;
}

.fixed-plugin .dropdown .dropdown-menu {
  transform: translate3d(0, -5%, 0) !important;
  border-radius: 10px;
}
.fixed-plugin .dropdown .dropdown-menu li.adjustments-line {
  border-bottom: 1px solid #ddd;
}
.fixed-plugin .dropdown .dropdown-menu li {
  padding: 5px 2px !important;
}
.fixed-plugin .dropdown .dropdown-menu .button-container a {
  font-size: 14px;
}
.fixed-plugin .dropdown .dropdown-menu .button-container.show {
  transform: translate3d(0, 0%, 0) !important;
  transform-origin: 0 0;
  left: -303px !important;
}

.fixed-plugin .dropdown .dropdown-menu {
  transform: translate3d(0, -5%, 0) !important;
  top: -40px !important;
  opacity: 0;
  left: -303px !important;
  transform-origin: 0 0;
}

.fixed-plugin .dropdown.show .dropdown-menu {
  opacity: 1;
  transform: translate3d(0, 0%, 0) !important;
  transform-origin: 0 0;
  left: -303px !important;
}

.fixed-plugin .dropdown-menu:before,
.fixed-plugin .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 65px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}

.fixed-plugin .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -16px;
}

.fixed-plugin .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #fff;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -15px;
}

.modal.show .modal-dialog {
  transform: translate(0, 30%);
}
.modal.modal-mini .modal-dialog {
  max-width: 255px;
  margin: 0 auto;
}
.modal .modal-content .modal-header {
  border-bottom: none;
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
}
.modal .modal-content .modal-header .modal-profile {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  text-align: center;
  line-height: 5.7;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
}
.modal .modal-content .modal-header .modal-profile i {
  font-size: 32px;
  padding-top: 24px;
}
.modal .modal-content .modal-body {
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  line-height: 1.9;
}
.modal .modal-content .modal-body + .modal-footer {
  padding-top: 0;
}
.modal .modal-content .modal-footer {
  border-top: none;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  justify-content: space-between;
}
.modal .modal-content .modal-footer .btn {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal .modal-content .modal-footer .btn:hover, .modal .modal-content .modal-footer .btnfocus {
  text-decoration: none;
}

.btn {
  border-width: 2px;
  background-color: transparent;
  font-weight: 400;
  opacity: 0.8;
  filter: alpha(opacity=80);
  padding: 8px 16px;
  border-color: #888888;
  color: #888888;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .open > .btn.dropdown-toggle {
  background-color: transparent;
  color: #777777;
  border-color: #777777;
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active {
  background-color: transparent;
  border-color: #888888;
}
.btn.btn-fill {
  color: #FFFFFF;
  background-color: #888888;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn.btn-fill:hover, .btn.btn-fill:focus, .btn.btn-fill:active, .btn.btn-fill.active, .open > .btn.btn-fill.dropdown-toggle {
  background-color: #777777;
  color: #FFFFFF;
}
.btn.btn-fill .caret {
  border-top-color: #FFFFFF;
}
.btn .caret {
  border-top-color: #888888;
}
.btn:hover, .btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
  box-shadow: none;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn.btn-icon {
  padding: 8px;
}

.btn-primary {
  border-color: #3472F7;
  color: #3472F7;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open > .btn-primary.dropdown-toggle {
  background-color: transparent;
  color: #1D62F0;
  border-color: #1D62F0;
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: transparent;
  border-color: #3472F7;
}
.btn-primary.btn-fill {
  color: #FFFFFF;
  background-color: #3472F7;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-primary.btn-fill:hover, .btn-primary.btn-fill:focus, .btn-primary.btn-fill:active, .btn-primary.btn-fill.active, .open > .btn-primary.btn-fill.dropdown-toggle {
  background-color: #1D62F0;
  color: #FFFFFF;
}
.btn-primary.btn-fill .caret {
  border-top-color: #FFFFFF;
}
.btn-primary .caret {
  border-top-color: #3472F7;
}

.btn-success {
  border-color: #87CB16;
  color: #87CB16;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .open > .btn-success.dropdown-toggle {
  background-color: transparent;
  color: #049F0C;
  border-color: #049F0C;
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: transparent;
  border-color: #87CB16;
}
.btn-success.btn-fill {
  color: #FFFFFF;
  background-color: #87CB16;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-success.btn-fill:hover, .btn-success.btn-fill:focus, .btn-success.btn-fill:active, .btn-success.btn-fill.active, .open > .btn-success.btn-fill.dropdown-toggle {
  background-color: #049F0C;
  color: #FFFFFF;
}
.btn-success.btn-fill .caret {
  border-top-color: #FFFFFF;
}
.btn-success .caret {
  border-top-color: #87CB16;
}

.btn-info {
  border-color: #1DC7EA;
  color: #1DC7EA;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .open > .btn-info.dropdown-toggle {
  background-color: transparent;
  color: #42d0ed;
  border-color: #42d0ed;
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: transparent;
  border-color: #1DC7EA;
}
.btn-info.btn-fill {
  color: #FFFFFF;
  background-color: #1DC7EA;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-info.btn-fill:hover, .btn-info.btn-fill:focus, .btn-info.btn-fill:active, .btn-info.btn-fill.active, .open > .btn-info.btn-fill.dropdown-toggle {
  background-color: #42d0ed;
  color: #FFFFFF;
}
.btn-info.btn-fill .caret {
  border-top-color: #FFFFFF;
}
.btn-info .caret {
  border-top-color: #1DC7EA;
}

.btn-warning {
  border-color: #FF9500;
  color: #FF9500;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .open > .btn-warning.dropdown-toggle {
  background-color: transparent;
  color: #ED8D00;
  border-color: #ED8D00;
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: transparent;
  border-color: #FF9500;
}
.btn-warning.btn-fill {
  color: #FFFFFF;
  background-color: #FF9500;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-warning.btn-fill:hover, .btn-warning.btn-fill:focus, .btn-warning.btn-fill:active, .btn-warning.btn-fill.active, .open > .btn-warning.btn-fill.dropdown-toggle {
  background-color: #ED8D00;
  color: #FFFFFF;
}
.btn-warning.btn-fill .caret {
  border-top-color: #FFFFFF;
}
.btn-warning .caret {
  border-top-color: #FF9500;
}

.btn-danger {
  border-color: #FF4A55;
  color: #FF4A55;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .open > .btn-danger.dropdown-toggle {
  background-color: transparent;
  color: #EE2D20;
  border-color: #EE2D20;
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: transparent;
  border-color: #FF4A55;
}
.btn-danger.btn-fill {
  color: #FFFFFF;
  background-color: #FF4A55;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-danger.btn-fill:hover, .btn-danger.btn-fill:focus, .btn-danger.btn-fill:active, .btn-danger.btn-fill.active, .open > .btn-danger.btn-fill.dropdown-toggle {
  background-color: #EE2D20;
  color: #FFFFFF;
}
.btn-danger.btn-fill .caret {
  border-top-color: #FFFFFF;
}
.btn-danger .caret {
  border-top-color: #FF4A55;
}

.btn-neutral {
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .open > .btn-neutral.dropdown-toggle {
  background-color: transparent;
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: transparent;
  border-color: #FFFFFF;
}
.btn-neutral.btn-fill {
  color: #FFFFFF;
  background-color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-neutral.btn-fill:hover, .btn-neutral.btn-fill:focus, .btn-neutral.btn-fill:active, .btn-neutral.btn-fill.active, .open > .btn-neutral.btn-fill.dropdown-toggle {
  background-color: #FFFFFF;
  color: #FFFFFF;
}
.btn-neutral.btn-fill .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral:active, .btn-neutral.active, .open > .btn-neutral.dropdown-toggle {
  background-color: #FFFFFF;
  color: #888888;
}
.btn-neutral.btn-fill, .btn-neutral.btn-fill:hover, .btn-neutral.btn-fill:focus {
  color: #888888;
}
.btn-neutral.btn-simple:active, .btn-neutral.btn-simple.active {
  background-color: transparent;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.btn-round {
  border-width: 1px;
  border-radius: 30px !important;
  padding: 9px 18px;
}
.btn-round.btn-icon {
  padding: 9px;
}

.btn-simple {
  border: 0;
  font-size: 16px;
  padding: 8px 16px;
}
.btn-simple.btn-icon {
  padding: 8px;
}

.btn-lg {
  font-size: 18px;
  border-radius: 6px;
  padding: 14px 30px;
  font-weight: 400;
}
.btn-lg.btn-round {
  padding: 15px 30px;
}
.btn-lg.btn-simple {
  padding: 16px 30px;
}

.btn-sm {
  font-size: 12px;
  border-radius: 3px;
  padding: 5px 10px;
}
.btn-sm.btn-round {
  padding: 6px 10px;
}
.btn-sm.btn-simple {
  padding: 7px 10px;
}

.btn-xs {
  font-size: 12px;
  border-radius: 3px;
  padding: 1px 5px;
}
.btn-xs.btn-round {
  padding: 2px 5px;
}
.btn-xs.btn-simple {
  padding: 3px 5px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-social {
  opacity: 0.85;
}

.btn-twitter {
  border-color: #55acee;
  color: #55acee;
}
.btn-twitter:hover {
  opacity: 1 !important;
  border-color: #55acee;
  color: #55acee;
}

.btn-facebook {
  border-color: #3b5998;
  color: #3b5998;
}
.btn-facebook:hover {
  opacity: 1 !important;
  border-color: #3b5998;
  color: #3b5998;
}

.form-control::-moz-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-moz-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control::-webkit-input-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-ms-input-placeholder {
  color: #DDDDDD;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
  color: #565656;
  padding: 8px 12px;
  height: 40px;
  box-shadow: none;
}
.form-control:focus {
  background-color: #FFFFFF;
  border: 1px solid #AAAAAA;
  box-shadow: none;
  outline: 0 !important;
  color: #333333;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  border-color: #E3E3E3;
  box-shadow: none;
}
.has-success .form-control {
  color: #87CB16;
}
.has-success .form-control:focus {
  border-color: #87CB16;
}
.has-error .form-control {
  color: #FF4A55;
}
.has-error .form-control:focus {
  border-color: #FF4A55;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 14px;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 4px 4px 0 0;
  border-bottom-color: transparent;
}

.input-lg {
  height: 55px;
  padding: 14px 30px;
}

.has-error .form-control-feedback {
  color: #FF4A55;
}

.has-success .form-control-feedback {
  color: #87CB16;
}

.input-group-addon {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
}
.has-success .input-group-addon, .has-error .input-group-addon {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
}
.has-error .form-control:focus + .input-group-addon {
  border-color: #FF4A55;
  color: #FF4A55;
}
.has-success .form-control:focus + .input-group-addon {
  border-color: #87CB16;
  color: #87CB16;
}
.form-control:focus + .input-group-addon, .form-control:focus ~ .input-group-addon {
  background-color: #FFFFFF;
  border-color: #9A9A9A;
}

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #F5F5F5;
  color: #888888;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 9px 16px;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #DDDDDD;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

.input-group-focus .input-group-addon {
  border-color: #9A9A9A;
}

.alert {
  border: 0;
  border-radius: 0;
  color: #FFFFFF;
  padding: 10px 15px;
  font-size: 14px;
}
.container .alert {
  border-radius: 4px;
}
.navbar .alert {
  border-radius: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 85px;
  width: 100%;
  z-index: 3;
}
.navbar:not(.navbar-transparent) .alert {
  top: 70px;
}
.alert span[data-notify=icon] {
  font-size: 30px;
  display: block;
  left: 15px;
  position: absolute;
  top: 50%;
  margin-top: -15px;
}
.alert i.nc-simple-remove {
  font-size: 12px !important;
  font: bold normal normal 14px/1 "nucleo-icons";
}
.alert button.close {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
  z-index: 1033;
  background-color: #FFFFFF;
  display: block;
  border-radius: 50%;
  opacity: 0.4;
  line-height: 9px;
  width: 25px;
  height: 25px;
  outline: 0 !important;
  text-align: center;
  padding: 3px;
  font-weight: 300;
}
.alert button.close:hover {
  opacity: 0.55;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert[data-notify=container] {
  padding: 10px 10px 10px 20px;
  border-radius: 4px;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

.alert-primary {
  background-color: #4091e2;
}

.alert-info {
  background-color: #63d8f1;
}

.alert-success {
  background-color: #a1e82c;
}

.alert-warning {
  background-color: #ffbc67;
}

.alert-danger {
  background-color: #fc727a;
}

.table .radio,
.table .checkbox {
  position: relative;
  height: 20px;
  display: block;
  width: 20px;
  padding: 0px 0px;
  margin: 0px 5px;
  text-align: center;
}
.table .radio .icons,
.table .checkbox .icons {
  left: 5px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 8px;
  vertical-align: middle;
}
.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 12px;
  text-transform: uppercase;
  color: #9A9A9A;
  font-weight: 400;
  padding-bottom: 5px;
  border-top: none !important;
  border-bottom: none;
  text-align: left !important;
}
.table .td-actions .btn {
  opacity: 0.36;
  filter: alpha(opacity=36);
}
.table .td-actions .btn.btn-xs {
  padding-left: 3px;
  padding-right: 3px;
}
.table .td-actions {
  min-width: 90px;
}
.table > tbody > tr {
  position: relative;
}
.table > tbody > tr:hover .td-actions .btn {
  opacity: 1;
  filter: alpha(opacity=100);
}
.table .btn:focus {
  box-shadow: none !important;
}

.table-upgrade .table tr td {
  width: 100%;
}

.table .form-check .form-check-sign, .table .form-check .form-check-sign:after, .table .form-check .form-check-sign:before {
  margin-top: -16px;
}

.from-check,
.form-check-radio {
  margin-bottom: 12px;
  position: relative;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 35px;
  line-height: 26px;
  margin-bottom: 0;
  text-transform: capitalize;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  font-family: "Font Awesome 5 Free";
  content: "\\f0c8";
  color: #888888;
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  margin-left: -23px;
  font-size: 18px;
  cursor: pointer;
  transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
  font-family: "Font Awesome 5 Free";
  content: "\\f14a";
  text-align: center;
  opacity: 0;
  color: #1DC7EA;
  border: 0;
  background-color: inherit;
  margin-left: -23px;
  font-weight: bold;
}
.form-check .form-check-sign::before {
  margin-left: -22px;
}
.form-check.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

#RegisterValidation .card .form-check .form-check-sign:before {
  margin-left: -27px;
}

.form-check .form-check-input:disabled + .form-check-sign:before,
.form-check .form-check-input:disabled + .form-check-sign:after,
.radio input[type=radio]:disabled + label,
.form-check .form-check-input:disabled:checked + .form-check-sign::after {
  color: #ddd;
  pointer-events: none;
}

.form-check.disabled .form-check-label {
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.form-check-radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check input[type=checkbox]:checked + .form-check-sign::before {
  opacity: 0;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check .form-check-label input[type=checkbox]:disabled + .form-check-sign,
.form-check-radio input[type=radio]:disabled + .form-check-sign {
  pointer-events: none !important;
}

.form-check.checkbox-inline {
  display: inline-block;
}

.form-check-radio .form-check-label {
  padding-left: 2.2rem;
}
.form-check-radio.disabled .form-check-label {
  color: #9A9A9A;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
  font-family: "FontAwesome";
  content: "\\f10c";
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 34px;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
  transition: opacity 0.3s linear;
  content: " ";
  display: block;
  margin-left: 5px;
  font-size: 18px;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  font-family: "FontAwesome";
  content: "\\f192";
  position: absolute;
  left: 5.3px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
  transition: opacity 0.3s linear;
}

.form-check input[type=radio]:checked + .form-check-sign::before {
  opacity: 0;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9A9A9A;
}

.card.stacked-form .form-check .form-check-label, .card.horizontal-form .form-check .form-check-label {
  padding-left: 22px !important;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: transparent;
}

.navbar {
  border: 0;
  font-size: 16px;
  border-radius: 0;
  min-height: 50px;
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.navbar .navbar-brand {
  font-weight: 400;
  margin: 5px 0px;
  font-size: 20px;
  color: #888888;
}
.navbar .navbar-brand:hover {
  color: #5e5e5e;
}
.navbar .navbar-toggler {
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler.navbar-toggler-left {
  position: relative;
  left: 0;
  padding-left: 0;
}
.navbar .navbar-toggler.navbar-toggler-right {
  padding-right: 0;
  top: 18px;
}
.navbar .navbar-toggler .navbar-toggler-bar {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 auto;
}
.navbar .navbar-toggler .burger-lines {
  display: block;
  position: relative;
  background-color: #888;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  margin: 4px auto;
}
.navbar .navbar-nav .nav-item .nav-link {
  color: #888888;
  padding: 10px 15px;
  margin: 10px 3px;
  position: relative;
  display: inline-flex;
  line-height: 40px;
}
.navbar .navbar-nav .nav-item .nav-link.btn {
  margin: 15px 3px;
  padding: 8px 16px;
}
.navbar .navbar-nav .nav-item .nav-link.btn-round {
  margin: 16px 3px;
}
.navbar .navbar-nav .nav-item .nav-link[class^=fa], .navbar .navbar-nav .nav-item .nav-link[class^=fas], .navbar .navbar-nav .nav-item .nav-link[class^=far], .navbar .navbar-nav .nav-item .nav-link[class^=fal], .navbar .navbar-nav .nav-item .nav-link[class^=fad], .navbar .navbar-nav .nav-item .nav-link[class^=fab] {
  font-size: 19px;
  position: relative;
  line-height: 40px;
  top: 1px;
}
.navbar .navbar-nav .nav-item .nav-link:hover {
  color: #1DC7EA;
}
.navbar .navbar-nav .nav-item .dropdown-menu {
  border-radius: 10px;
  margin-top: -5px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .divider {
  height: 1px;
  margin: 5px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.navbar .navbar-nav .notification {
  position: absolute;
  background-color: #FB404B;
  text-align: center;
  border-radius: 10px;
  min-width: 18px;
  padding: 0 5px;
  height: 18px;
  font-size: 12px;
  color: #FFFFFF;
  font-weight: bold;
  line-height: 18px;
  top: 10px;
  left: 7px;
}
.navbar .navbar-nav .dropdown-toggle:after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 5px;
  margin-top: 20px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.navbar .btn {
  margin: 15px 3px;
  font-size: 14px;
}
.navbar .btn-simple {
  font-size: 16px;
}
.navbar.fixed {
  width: calc(100% - calc(100% - 260px));
  right: 0;
  left: auto;
  border-radius: 0;
}
.navbar .nc-icon {
  font-weight: 700;
  margin-top: 10px;
}

.navbar-transparent .navbar-brand, [class*=navbar-ct] .navbar-brand {
  color: #FFFFFF;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .navbar-brand:focus, .navbar-transparent .navbar-brand:hover, [class*=navbar-ct] .navbar-brand:focus, [class*=navbar-ct] .navbar-brand:hover {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
  color: #FFFFFF;
}
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn), [class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn) {
  color: #FFFFFF;
  border-color: #FFFFFF;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.navbar-transparent .navbar-nav .active .nav-link:not(.btn),
.navbar-transparent .navbar-nav .active .nav-link:hover:not(.btn),
.navbar-transparent .navbar-nav .active .nav-link:focus:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:hover:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:focus:not(.btn), [class*=navbar-ct] .navbar-nav .active .nav-link:not(.btn),
[class*=navbar-ct] .navbar-nav .active .nav-link:hover:not(.btn),
[class*=navbar-ct] .navbar-nav .active .nav-link:focus:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:hover:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:focus:not(.btn) {
  background-color: transparent;
  border-radius: 3px;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .navbar-nav .nav .nav-item .nav-link.btn:hover, [class*=navbar-ct] .navbar-nav .nav .nav-item .nav-link.btn:hover {
  background-color: transparent;
}
.navbar-transparent .navbar-nav .show .nav-link,
.navbar-transparent .navbar-nav .show .nav-link:hover,
.navbar-transparent .navbar-nav .show .nav-link:focus, [class*=navbar-ct] .navbar-nav .show .nav-link,
[class*=navbar-ct] .navbar-nav .show .nav-link:hover,
[class*=navbar-ct] .navbar-nav .show .nav-link:focus {
  background-color: transparent;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .btn-default, [class*=navbar-ct] .btn-default {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.navbar-transparent .btn-default.btn-fill, [class*=navbar-ct] .btn-default.btn-fill {
  color: #9A9A9A;
  background-color: #FFFFFF;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .btn-default.btn-fill:hover,
.navbar-transparent .btn-default.btn-fill:focus,
.navbar-transparent .btn-default.btn-fill:active,
.navbar-transparent .btn-default.btn-fill.active,
.navbar-transparent .show .dropdown-toggle.btn-fill.btn-default, [class*=navbar-ct] .btn-default.btn-fill:hover,
[class*=navbar-ct] .btn-default.btn-fill:focus,
[class*=navbar-ct] .btn-default.btn-fill:active,
[class*=navbar-ct] .btn-default.btn-fill.active,
[class*=navbar-ct] .show .dropdown-toggle.btn-fill.btn-default {
  border-color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-transparent .dropdown-menu .divider {
  background-color: rgba(255, 255, 255, 0.2);
}

.navbar-default {
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn) {
  color: #9A9A9A;
}
.navbar-default .navbar-nav .active .nav-link,
.navbar-default .navbar-nav .active .nav-link:not(.btn):hover,
.navbar-default .navbar-nav .active .nav-link:not(.btn):focus,
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn):focus {
  background-color: transparent;
  border-radius: 3px;
  color: #1DC7EA;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-default .navbar-nav .show .nav-link,
.navbar-default .navbar-nav .show .nav-link:hover,
.navbar-default .navbar-nav .show .nav-link:focus {
  background-color: transparent;
  color: #1DC7EA;
}
.navbar-default .navbar-nav .navbar-toggle:hover, .navbar-default .navbar-nav .navbar-toggle:focus {
  background-color: transparent;
}
.navbar-default:not(.navbar-transparent) .btn-default:hover {
  color: #1DC7EA;
  border-color: #1DC7EA;
}
.navbar-default:not(.navbar-transparent) .btn-neutral, .navbar-default:not(.navbar-transparent) .btn-neutral:hover, .navbar-default:not(.navbar-transparent) .btn-neutral:active {
  color: #9A9A9A;
}

/*      Navbar with icons            */
.navbar-icons.navbar .navbar-brand {
  margin-top: 12px;
  margin-bottom: 12px;
}
.navbar-icons .navbar-nav .nav-item .nav-link {
  text-align: center;
  padding: 6px 15px;
  margin: 6px 3px;
}
.navbar-icons .navbar-nav [class^=pe] {
  font-size: 30px;
  position: relative;
}
.navbar-icons .navbar-nav p {
  margin: 3px 0 0;
}

.navbar-form {
  box-shadow: none;
}
.navbar-form .form-control {
  border-radius: 0;
  border: 0;
  padding: 0;
  background-color: transparent;
  height: 22px;
  font-size: 16px;
  line-height: 1.5;
  color: #E3E3E3;
}
.navbar-transparent .navbar-form .form-control, [class*=navbar-ct] .navbar-form .form-control {
  color: #FFFFFF;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
}

.navbar-ct-blue {
  background-color: #4091e2;
}

.navbar-ct-azure {
  background-color: #63d8f1;
}

.navbar-ct-green {
  background-color: #a1e82c;
}

.navbar-ct-orange {
  background-color: #ffbc67;
}

.navbar-ct-red {
  background-color: #fc727a;
}

.navbar-transparent {
  padding-top: 15px;
  background-color: transparent;
  border-bottom: 1px solid transparent;
}

.navbar-toggle {
  margin-top: 19px;
  margin-bottom: 19px;
  border: 0;
}
.navbar-toggle .icon-bar {
  background-color: #FFFFFF;
}
.navbar-toggle .navbar-collapse,
.navbar-toggle .navbar-form {
  border-color: transparent;
}
.navbar-toggle.navbar-default .navbar-toggle:hover, .navbar-toggle.navbar-default .navbar-toggle:focus {
  background-color: transparent;
}

.footer {
  background-color: #FFFFFF;
}
.footer .footer-menu {
  height: 41px;
}
.footer nav > ul {
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: normal;
}
.footer nav > ul a:not(.btn) {
  color: #9A9A9A;
  display: block;
  margin-bottom: 3px;
}
.footer nav > ul a:not(.btn):hover, .footer nav > ul a:not(.btn):focus {
  color: #777777;
}
.footer .social-area {
  padding: 15px 0;
}
.footer .social-area h5 {
  padding-bottom: 15px;
}
.footer .social-area > a:not(.btn) {
  color: #9A9A9A;
  display: inline-block;
  vertical-align: top;
  padding: 10px 5px;
  font-size: 20px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
}
.footer .social-area > a:not(.btn):hover, .footer .social-area > a:not(.btn):focus {
  color: #777777;
}
.footer .copyright {
  color: #777777;
  padding: 10px 15px;
  margin: 10px 3px;
  line-height: 20px;
  font-size: 14px;
}
.footer hr {
  border-color: #DDDDDD;
}
.footer .title {
  color: #777777;
}

.footer-default {
  background-color: #F5F5F5;
}

.footer:not(.footer-big) nav > ul {
  font-size: 14px;
}
.footer:not(.footer-big) nav > ul li {
  margin-left: 20px;
  float: left;
}
.footer:not(.footer-big) nav > ul a {
  padding: 10px 0px;
  margin: 10px 10px 10px 0px;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}
@keyframes shake {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(10px, 0, 0);
  }
}
.shake {
  animation-name: shake;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.fadeOutDown {
  animation-name: fadeOutDown;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.fadeOutUp {
  animation-name: fadeOutUp;
}

.dropdown-menu {
  visibility: hidden;
  margin: 0;
  padding: 0;
  border-radius: 10px;
  display: block;
  z-index: 9000;
  position: absolute;
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
}
.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.select .dropdown-menu {
  border-radius: 0 0 10px 10px;
  box-shadow: none;
  transform-origin: 50% -40px;
  transform: scale(1);
  transition: all 150ms linear;
  margin-top: -20px;
}
.select.show .dropdown-menu {
  margin-top: -1px;
}
.dropdown-menu .dropdown-item {
  padding: 8px 16px;
  color: #333333;
}
.dropdown-menu .dropdown-item img {
  margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu > li:first-child > a {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu > li:last-child > a {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.select .dropdown-menu > li:first-child > a {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #F5F5F5;
  color: #333333;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu.dropdown-blue > li > a:hover, .dropdown-menu.dropdown-blue > li > a:focus {
  background-color: rgba(52, 114, 247, 0.2);
}
.dropdown-menu.dropdown-azure > li > a:hover, .dropdown-menu.dropdown-azure > li > a:focus {
  background-color: rgba(29, 199, 234, 0.2);
}
.dropdown-menu.ct-green > li > a:hover, .dropdown-menu.ct-green > li > a:focus {
  background-color: rgba(135, 203, 22, 0.2);
}
.dropdown-menu.dropdown-orange > li > a:hover, .dropdown-menu.dropdown-orange > li > a:focus {
  background-color: rgba(255, 149, 0, 0.2);
}
.dropdown-menu.dropdown-red > li > a:hover, .dropdown-menu.dropdown-red > li > a:focus {
  background-color: rgba(255, 74, 85, 0.2);
}
.dropdown-menu .dropdown-item i[class*=nc-icon] {
  font-size: 18px;
  text-align: center;
  line-height: 25px;
  float: left;
  padding-right: 10px;
}
.dropdown-menu.dropdown-menu-right:before, .dropdown-menu.dropdown-menu-right:after {
  right: 12px !important;
  left: auto !important;
}

.dropdown-with-icons > li > a {
  padding-left: 0px;
  line-height: 28px;
}
.dropdown-with-icons i {
  text-align: center;
  line-height: 28px;
  float: left;
}
.dropdown-with-icons i[class^=pe-] {
  font-size: 24px;
  width: 46px;
}
.dropdown-with-icons i[class^=fa], .dropdown-with-icons i[class^=fas], .dropdown-with-icons i[class^=far], .dropdown-with-icons i[class^=fal], .dropdown-with-icons i[class^=fad], .dropdown-with-icons i[class^=fab] {
  font-size: 14px;
  width: 38px;
}

.btn-group.select {
  overflow: hidden;
}

.btn-group.select.show {
  overflow: visible;
}

.card {
  border-radius: 4px;
  background-color: #FFFFFF;
  margin-bottom: 30px;
}
.card .card-image {
  width: 100%;
  overflow: hidden;
  height: 260px;
  border-radius: 4px 4px 0 0;
  position: relative;
  transform-style: preserve-3d;
}
.card .card-image img {
  width: 100%;
}
.card .filter {
  position: absolute;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.68);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  opacity: 0;
  filter: alpha(opacity=0);
}
.card .filter .btn {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.card:hover .filter {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .btn-hover {
  opacity: 0;
  filter: alpha(opacity=0);
}
.card:hover .btn-hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .card-body {
  padding: 15px 15px 10px 15px;
}
.card .card-header {
  padding: 15px 15px 0;
  background-color: #FFFFFF;
  border-bottom: none !important;
}
.card .card-category,
.card label {
  font-size: 14px;
  font-weight: 400;
  color: #9A9A9A;
  margin-bottom: 0px;
}
.card .card-category i,
.card label i {
  font-size: 16px;
}
.card label {
  font-size: 12px;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.card .card-title {
  margin: 0;
  color: #333333;
  font-weight: 300;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}
.card .description {
  font-size: 14px;
  color: #333;
}
.card .card-footer {
  padding-top: 0;
  background-color: transparent;
  line-height: 30px;
  border-top: none !important;
  font-size: 14px;
}
.card .card-footer .legend {
  padding: 5px 0;
}
.card .card-footer hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.card .stats {
  color: #a9a9a9;
}
.card .card-footer div {
  display: inline-block;
}
.card .author {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.card .author i {
  font-size: 14px;
}
.card h6 {
  font-size: 12px;
  margin: 0;
}
.card.card-separator:after {
  height: 100%;
  right: -15px;
  top: 0;
  width: 1px;
  background-color: #DDDDDD;
  card-body: "";
  position: absolute;
}
.card .ct-chart {
  margin: 30px 0 30px;
  height: 245px;
}
.card .ct-label {
  font-size: 1rem !important;
}
.card .table tbody td:first-child,
.card .table thead th:first-child {
  padding-left: 15px;
}
.card .table tbody td:last-child,
.card .table thead th:last-child {
  padding-right: 15px;
}
.card .alert {
  border-radius: 4px;
  position: relative;
}
.card .alert.alert-with-icon {
  padding-left: 65px;
}

.card-stats .card-body {
  padding: 15px 15px 0px;
}
.card-stats .card-body .numbers {
  font-size: 1.8rem;
  text-align: right;
}
.card-stats .card-body .numbers p {
  margin-bottom: 0;
}
.card-stats .card-footer {
  padding: 0px 15px 10px 15px;
}
.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px;
}
.card-stats .icon-big i {
  font-weight: 700;
  line-height: 59px;
}

.card-user .card-image {
  height: 110px;
}
.card-user .card-image-plain {
  height: 0;
  margin-top: 110px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -70px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid #FFFFFF;
  position: relative;
  margin-bottom: 15px;
}
.card-user .avatar.border-gray {
  border-color: #EEEEEE;
}
.card-user .title {
  line-height: 24px;
}
.card-user .card-body {
  min-height: 240px;
}

.card-user .card-footer,
.card-price .card-footer {
  padding: 5px 15px 10px;
}
.card-user hr,
.card-price hr {
  margin: 5px 15px;
}

.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card-plain .card-image {
  border-radius: 4px;
}

.card.card-plain {
  border: none !important;
}
.card.card-plain .card-header {
  background-color: transparent !important;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.3rem;
  line-height: 1;
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-vertical.ct-start {
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-label.ct-vertical.ct-end {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-point {
  stroke-width: 8px;
  stroke-linecap: round;
}

.ct-line {
  fill: none;
  stroke-width: 3px;
}

.ct-area {
  stroke: none;
  fill-opacity: 0.8;
}

.ct-bar {
  fill: none;
  stroke-width: 10px;
}

.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}

.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {
  stroke: #1DC7EA;
}
.ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
  fill: #1DC7EA;
}

.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {
  stroke: #FB404B;
}
.ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
  fill: #FB404B;
}

.ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut {
  stroke: #FFA534;
}
.ct-series-c .ct-slice-pie, .ct-series-c .ct-area {
  fill: #FFA534;
}

.ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut {
  stroke: #9368E9;
}
.ct-series-d .ct-slice-pie, .ct-series-d .ct-area {
  fill: #9368E9;
}

.ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut {
  stroke: #87CB16;
}
.ct-series-e .ct-slice-pie, .ct-series-e .ct-area {
  fill: #87CB16;
}

.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {
  stroke: #1F77D0;
}
.ct-series-f .ct-slice-pie, .ct-series-f .ct-area {
  fill: #1F77D0;
}

.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {
  stroke: #5e5e5e;
}
.ct-series-g .ct-slice-pie, .ct-series-g .ct-area {
  fill: #5e5e5e;
}

.ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut {
  stroke: #dd4b39;
}
.ct-series-h .ct-slice-pie, .ct-series-h .ct-area {
  fill: #dd4b39;
}

.ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut {
  stroke: #35465c;
}
.ct-series-i .ct-slice-pie, .ct-series-i .ct-area {
  fill: #35465c;
}

.ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut {
  stroke: #e52d27;
}
.ct-series-j .ct-slice-pie, .ct-series-j .ct-area {
  fill: #e52d27;
}

.ct-series-k .ct-point, .ct-series-k .ct-line, .ct-series-k .ct-bar, .ct-series-k .ct-slice-donut {
  stroke: #55acee;
}
.ct-series-k .ct-slice-pie, .ct-series-k .ct-area {
  fill: #55acee;
}

.ct-series-l .ct-point, .ct-series-l .ct-line, .ct-series-l .ct-bar, .ct-series-l .ct-slice-donut {
  stroke: #cc2127;
}
.ct-series-l .ct-slice-pie, .ct-series-l .ct-area {
  fill: #cc2127;
}

.ct-series-m .ct-point, .ct-series-m .ct-line, .ct-series-m .ct-bar, .ct-series-m .ct-slice-donut {
  stroke: #1769ff;
}
.ct-series-m .ct-slice-pie, .ct-series-m .ct-area {
  fill: #1769ff;
}

.ct-series-n .ct-point, .ct-series-n .ct-line, .ct-series-n .ct-bar, .ct-series-n .ct-slice-donut {
  stroke: #6188e2;
}
.ct-series-n .ct-slice-pie, .ct-series-n .ct-area {
  fill: #6188e2;
}

.ct-series-o .ct-point, .ct-series-o .ct-line, .ct-series-o .ct-bar, .ct-series-o .ct-slice-donut {
  stroke: #a748ca;
}
.ct-series-o .ct-slice-pie, .ct-series-o .ct-area {
  fill: #a748ca;
}

.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 100%;
}
.ct-square:after {
  content: "";
  display: table;
  clear: both;
}
.ct-square > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 93.75%;
}
.ct-minor-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 88.8888888889%;
}
.ct-major-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 83.3333333333%;
}
.ct-minor-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 80%;
}
.ct-major-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 75%;
}
.ct-perfect-fourth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fourth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 66.6666666667%;
}
.ct-perfect-fifth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fifth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 61.804697157%;
}
.ct-golden-section:after {
  content: "";
  display: table;
  clear: both;
}
.ct-golden-section > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 60%;
}
.ct-major-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 53.3333333333%;
}
.ct-major-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 50%;
}
.ct-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 40%;
}
.ct-major-tenth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-tenth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-eleventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 33.3333333333%;
}
.ct-major-twelfth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-twelfth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 25%;
}
.ct-double-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-double-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

@media (min-width: 992px) {
  .navbar-form {
    margin-top: 21px;
    margin-bottom: 21px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .navbar-nav .nav-item .dropdown-menu, .dropdown .dropdown-menu {
    transform: scale(0);
    transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);
  }
  .navbar-nav .nav-item.show .dropdown-menu, .dropdown.show .dropdown-menu {
    transform: scale(1);
    transform-origin: 29px -50px;
  }
  .footer {
    height: 60px;
  }
  .footer .footer-menu {
    float: left;
  }
  .footer .copyright {
    float: right;
  }
  .navbar-nav .nav-item .dropdown-menu:before {
    border-bottom: 11px solid rgba(0, 0, 0, 0.2);
    border-left: 11px solid rgba(0, 0, 0, 0);
    border-right: 11px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -11px;
  }
  .navbar-nav .nav-item .dropdown-menu:after {
    border-bottom: 11px solid #FFFFFF;
    border-left: 11px solid rgba(0, 0, 0, 0);
    border-right: 11px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -10px;
  }
  .navbar-nav.navbar-right .nav-item .dropdown-menu:before {
    left: auto;
    right: 12px;
  }
  .navbar-nav.navbar-right .nav-item .dropdown-menu:after {
    left: auto;
    right: 12px;
  }
  .footer:not(.footer-big) nav > ul li:first-child {
    margin-left: 0;
  }
  .card form [class*=col-] {
    padding: 6px;
  }
  .card form [class*=col-]:first-child {
    padding-left: 15px;
  }
  .card form [class*=col-]:last-child {
    padding-right: 15px;
  }
}
/*          Changes for small display      */
@media (max-width: 991px) {
  .sidebar {
    right: 0 !important;
    left: auto;
    position: absolute;
    transform: translate3d(262px, 0, 0) !important;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    position: absolute;
    left: 0;
    transform: translate3d(-250px, 0, 0) !important;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .sidebar {
    transform: translate3d(10px, 0, 0) !important;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .main-panel {
    transform: translate3d(0px, 0, 0) !important;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-item.active-pro {
    position: relative !important;
  }
  .nav-mobile-menu {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin-bottom: 15px;
    padding-bottom: 15px;
    padding-top: 5px;
  }
  .nav-mobile-menu .dropdown .dropdown-menu {
    position: static !important;
    float: none;
    width: auto;
    color: #FFFFFF;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item {
    margin: 5px 15px 0px 40px;
    border-radius: 4px;
    color: #FFFFFF;
    opacity: 0.86;
    padding: 8px 50px;
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.23);
  }
  .nav-mobile-menu .nav-item .nav-link span {
    display: inline-block !important;
  }
  .nav-mobile-menu .nav-item .nav-link .no-icon {
    padding-left: 50px;
  }
  .main-panel {
    width: 100%;
  }
  .navbar-brand {
    padding: 15px 15px;
  }
  .navbar-transparent {
    padding-top: 15px;
    background-color: rgba(0, 0, 0, 0.45);
  }
  body {
    position: relative;
  }
  .wrapper {
    left: 0;
    background-color: white;
  }
  .navbar .container {
    left: 15px;
    width: 100%;
    position: relative;
    top: -10px;
  }
  .navbar-nav .nav-item {
    float: none;
    position: relative;
    display: block;
  }
  body > .navbar-collapse {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    right: 0;
    left: auto;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding: 0;
    transform: translate3d(260px, 0, 0);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  body > .navbar-collapse > ul {
    position: relative;
    z-index: 4;
    overflow-y: scroll;
    height: calc(100vh - 61px);
    width: 100%;
  }
  body > .navbar-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: #282828;
    display: block;
    content: "";
    z-index: 1;
  }
  body > .navbar-collapse .logo {
    position: relative;
    z-index: 4;
  }
  body > .navbar-collapse .nav li > a {
    padding: 10px 15px;
  }
  .nav-show .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-show .navbar .container {
    left: -250px;
  }
  .nav-show .wrapper {
    left: 0;
    transform: translate3d(-260px, 0, 0);
  }
  .navbar-toggle .icon-bar {
    display: block;
    position: relative;
    background: #fff;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    margin: 0 auto;
  }
  .navbar-header .navbar-toggle {
    margin: 10px 15px 10px 0;
    width: 40px;
    height: 40px;
  }
  .bar1,
.bar2,
.bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .dropdown-menu .divider {
    background-color: rgba(229, 229, 229, 0.15);
  }
  .navbar-nav {
    margin: 1px 0;
  }
  .navbar-nav .show .dropdown-menu .nav-item .nav-link {
    padding: 10px 15px 10px 60px;
  }
  [class*=navbar-] .navbar-nav > li > a,
[class*=navbar-] .navbar-nav > li > a:hover,
[class*=navbar-] .navbar-nav > li > a:focus,
[class*=navbar-] .navbar-nav .active > a,
[class*=navbar-] .navbar-nav .active > a:hover,
[class*=navbar-] .navbar-nav .active > a:focus,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:hover,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:focus,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:active {
    color: white;
  }
  [class*=navbar-] .navbar-nav > li > a,
[class*=navbar-] .navbar-nav > li > a:hover,
[class*=navbar-] .navbar-nav > li > a:focus {
    opacity: 0.7;
    background-color: transparent;
    outline: none;
  }
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:hover,
[class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:focus {
    background-color: rgba(255, 255, 255, 0.1);
  }
  [class*=navbar-] .navbar-nav.navbar-nav .show .dropdown-menu > li > a:active {
    opacity: 1;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:hover .caret {
    border-bottom-color: #fff;
    border-top-color: #fff;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:active .caret {
    border-bottom-color: white;
    border-top-color: white;
  }
  .dropdown-menu {
    display: none;
  }
  .navbar-fixed-top {
    -webkit-backface-visibility: hidden;
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 0;
    top: 0;
    left: auto;
    right: 250px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
  }
  .social-line .btn {
    margin: 0 0 10px 0;
  }
  .subscribe-line .form-control {
    margin: 0 0 10px 0;
  }
  .social-line.pull-right {
    float: none;
  }
  .social-area.pull-right {
    float: none !important;
  }
  .form-control + .form-control-feedback {
    margin-top: -8px;
  }
  .navbar-toggle:hover, .navbar-toggle:focus {
    background-color: transparent !important;
  }
  .btn.dropdown-toggle {
    margin-bottom: 0;
  }
  .media-post .author {
    width: 20%;
    float: none !important;
    display: block;
    margin: 0 auto 10px;
  }
  .media-post .media-body {
    width: 100%;
  }
  .navbar-collapse.collapse.in {
    display: block;
  }
  .navbar-header .collapse, .navbar-toggle {
    display: block !important;
  }
  .navbar-header {
    float: none;
  }
  .navbar-nav .show .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .navbar-collapse .navbar-nav p {
    line-height: 40px !important;
    margin: 0;
  }
  .navbar-collapse [class^=pe-7s-] {
    float: left;
    font-size: 20px;
    margin-right: 10px;
  }
}
@media (min-width: 992px) {
  .table-responsive {
    overflow: visible;
  }
}
@media (max-width: 991px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
  }
}
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  margin-left: 66px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #1DC7EA;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #FFFFFF;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.nc-icon {
  display: inline-block;
  font: normal normal normal 14px/1 "nucleo-icons";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
  font-size: 1.33333333em;
  vertical-align: -16%;
}

.nc-icon.x2 {
  font-size: 2em;
}

.nc-icon.x3 {
  font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.nc-icon.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .nc-icon {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
  top: 0;
  left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

.all-icons .font-icon-list .font-icon-detail i {
  font-size: 32px;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.nc-icon.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.nc-icon.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.nc-icon.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.nc-icon.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
  content: "\\ea01";
}

.nc-album-2::before {
  content: "\\ea02";
}

.nc-alien-33::before {
  content: "\\ea03";
}

.nc-align-center::before {
  content: "\\ea04";
}

.nc-align-left-2::before {
  content: "\\ea05";
}

.nc-ambulance::before {
  content: "\\ea06";
}

.nc-android::before {
  content: "\\ea07";
}

.nc-app::before {
  content: "\\ea08";
}

.nc-apple::before {
  content: "\\ea09";
}

.nc-atom::before {
  content: "\\ea0a";
}

.nc-attach-87::before {
  content: "\\ea0b";
}

.nc-audio-92::before {
  content: "\\ea0c";
}

.nc-backpack::before {
  content: "\\ea0d";
}

.nc-badge::before {
  content: "\\ea0e";
}

.nc-bag::before {
  content: "\\ea0f";
}

.nc-bank::before {
  content: "\\ea10";
}

.nc-battery-81::before {
  content: "\\ea11";
}

.nc-bell-55::before {
  content: "\\ea12";
}

.nc-bold::before {
  content: "\\ea13";
}

.nc-bulb-63::before {
  content: "\\ea14";
}

.nc-bullet-list-67::before {
  content: "\\ea15";
}

.nc-bus-front-12::before {
  content: "\\ea16";
}

.nc-button-pause::before {
  content: "\\ea17";
}

.nc-button-play::before {
  content: "\\ea18";
}

.nc-button-power::before {
  content: "\\ea19";
}

.nc-camera-20::before {
  content: "\\ea1a";
}

.nc-caps-small::before {
  content: "\\ea1b";
}

.nc-cart-simple::before {
  content: "\\ea1c";
}

.nc-cctv::before {
  content: "\\ea1d";
}

.nc-chart-bar-32::before {
  content: "\\ea1e";
}

.nc-chart-pie-35::before {
  content: "\\ea1f";
}

.nc-chart-pie-36::before {
  content: "\\ea20";
}

.nc-chart::before {
  content: "\\ea21";
}

.nc-chat-round::before {
  content: "\\ea22";
}

.nc-check-2::before {
  content: "\\ea23";
}

.nc-circle-09::before {
  content: "\\ea24";
}

.nc-circle::before {
  content: "\\ea25";
}

.nc-cloud-download-93::before {
  content: "\\ea26";
}

.nc-cloud-upload-94::before {
  content: "\\ea27";
}

.nc-compass-05::before {
  content: "\\ea28";
}

.nc-controller-modern::before {
  content: "\\ea29";
}

.nc-credit-card::before {
  content: "\\ea2a";
}

.nc-delivery-fast::before {
  content: "\\ea2b";
}

.nc-email-83::before {
  content: "\\ea2c";
}

.nc-email-85::before {
  content: "\\ea2d";
}

.nc-explore-2::before {
  content: "\\ea2e";
}

.nc-fav-remove::before {
  content: "\\ea2f";
}

.nc-favourite-28::before {
  content: "\\ea30";
}

.nc-globe-2::before {
  content: "\\ea31";
}

.nc-grid-45::before {
  content: "\\ea32";
}

.nc-headphones-2::before {
  content: "\\ea33";
}

.nc-html5::before {
  content: "\\ea34";
}

.nc-istanbul::before {
  content: "\\ea35";
}

.nc-key-25::before {
  content: "\\ea36";
}

.nc-layers-3::before {
  content: "\\ea37";
}

.nc-light-3::before {
  content: "\\ea38";
}

.nc-lock-circle-open::before {
  content: "\\ea39";
}

.nc-map-big::before {
  content: "\\ea3a";
}

.nc-mobile::before {
  content: "\\ea3c";
}

.nc-money-coins::before {
  content: "\\ea3b";
}

.nc-note-03::before {
  content: "\\ea3d";
}

.nc-notes::before {
  content: "\\ea3e";
}

.nc-notification-70::before {
  content: "\\ea3f";
}

.nc-palette::before {
  content: "\\ea40";
}

.nc-paper-2::before {
  content: "\\ea41";
}

.nc-pin-3::before {
  content: "\\ea42";
}

.nc-planet::before {
  content: "\\ea43";
}

.nc-preferences-circle-rotate::before {
  content: "\\ea44";
}

.nc-puzzle-10::before {
  content: "\\ea45";
}

.nc-quote::before {
  content: "\\ea46";
}

.nc-refresh-02::before {
  content: "\\ea47";
}

.nc-ruler-pencil::before {
  content: "\\ea48";
}

.nc-satisfied::before {
  content: "\\ea49";
}

.nc-scissors::before {
  content: "\\ea4a";
}

.nc-send::before {
  content: "\\ea4b";
}

.nc-settings-90::before {
  content: "\\ea4c";
}

.nc-settings-gear-64::before {
  content: "\\ea4d";
}

.nc-settings-tool-66::before {
  content: "\\ea4e";
}

.nc-simple-add::before {
  content: "\\ea4f";
}

.nc-simple-delete::before {
  content: "\\ea50";
}

.nc-simple-remove::before {
  content: "\\ea51";
}

.nc-single-02::before {
  content: "\\ea52";
}

.nc-single-copy-04::before {
  content: "\\ea53";
}

.nc-spaceship::before {
  content: "\\ea54";
}

.nc-square-pin::before {
  content: "\\ea55";
}

.nc-stre-down::before {
  content: "\\ea56";
}

.nc-stre-left::before {
  content: "\\ea57";
}

.nc-stre-right::before {
  content: "\\ea58";
}

.nc-stre-up::before {
  content: "\\ea59";
}

.nc-sun-fog-29::before {
  content: "\\ea5a";
}

.nc-support-17::before {
  content: "\\ea5b";
}

.nc-tablet-2::before {
  content: "\\ea5c";
}

.nc-tag-content::before {
  content: "\\ea5d";
}

.nc-tap-01::before {
  content: "\\ea5e";
}

.nc-time-alarm::before {
  content: "\\ea5f";
}

.nc-tv-2::before {
  content: "\\ea60";
}

.nc-umbrella-13::before {
  content: "\\ea61";
}

.nc-vector::before {
  content: "\\ea62";
}

.nc-watch-time::before {
  content: "\\ea63";
}

.nc-zoom-split::before {
  content: "\\ea64";
}

/* all icon font classes list here */
.rna-container .alert {
  border-radius: 4px;
}
.rna-container .alert button.close {
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rna-container .alert button.close span {
  margin-top: -4px;
}

.sidebar[data-color=black]:after {
  background: #282828;
  background: linear-gradient(to bottom, #282828 0%, rgba(17, 17, 17, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar .logo-img img {
  max-width: 40px;
  max-height: 40px;
}

@media (max-width: 991px) {
  .sidebar .nav > li.active.active-pro {
    position: relative;
    bottom: unset;
  }
}
#bodyClick {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/light-bootstrap-dashboard-react.scss","webpack://./src/assets/scss/lbd/_variables.scss","webpack://./src/assets/scss/lbd/mixins/_morphing-buttons.scss","webpack://./src/assets/scss/lbd/_typography.scss","webpack://./src/assets/scss/lbd/_misc.scss","webpack://./src/assets/scss/lbd/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/lbd/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/lbd/_buttons.scss","webpack://./src/assets/scss/lbd/mixins/_transparency.scss","webpack://./src/assets/scss/lbd/mixins/_buttons.scss","webpack://./src/assets/scss/lbd/_inputs.scss","webpack://./src/assets/scss/lbd/mixins/_inputs.scss","webpack://./src/assets/scss/lbd/_alerts.scss","webpack://./src/assets/scss/lbd/_tables.scss","webpack://./src/assets/scss/lbd/_checkbox-radio-switch.scss","webpack://./src/assets/scss/lbd/_navbars.scss","webpack://./src/assets/scss/lbd/mixins/_navbars.scss","webpack://./src/assets/scss/lbd/_footers.scss","webpack://./src/assets/scss/lbd/plugins/_animate.scss","webpack://./src/assets/scss/lbd/_dropdown.scss","webpack://./src/assets/scss/lbd/_cards.scss","webpack://./src/assets/scss/lbd/_chartist.scss","webpack://./src/assets/scss/lbd/mixins/_chartist.scss","webpack://./src/assets/scss/lbd/_responsive.scss","webpack://./src/assets/scss/lbd/_bootstrap-switch.scss","webpack://./src/assets/scss/lbd/_partial-nucleo-icons.scss","webpack://./src/assets/scss/lbdr/plugins/_react-notification-alert.scss","webpack://./src/assets/scss/lbdr/_sidebar-and-main-panel.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAAA;ACuDA,8BAAA;ACxCA;EACI;IAAO,uBAAA;EFGT;EEFE;IAAK,yBAAA;EFKP;AACF;AGvBA,kCAAA;AACA;;;;;;;;;;;;;;;;EAgBI,kCAAA;EACA,mCAAA;EACA,0DAAA;EACA,gBFsGyB;ADrD7B;;AG9CA;EACI,gBFiGyB;EEhGzB,mBAAA;AHiDJ;;AG9CA;EACI,eFkF2B;ADjC/B;;AG/CA;EACI,eFgF2B;AD9B/B;;AGhDA;EACI,eF8E2B;EE7E3B,mBAAA;AHmDJ;;AGjDA;EACI,eF2E2B;EE1E3B,iBAAA;AHoDJ;;AGlDA;EACI,eFwE2B;EEvE3B,mBAAA;AHqDJ;;AGnDA;EACI,eFqE2B;EEpE3B,gBF4EyB;EE3EzB,yBAAA;AHsDJ;;AGpDA;EACI,eFiE2B;EEhE3B,gBFyE2B;ADlB/B;;AGpDA;EACI,cFpCyB;EEqCzB,gBF+DyB;EE9DzB,gBFmE2B;ADZ/B;;AGpDA;EACI,cAAA;AHuDJ;;AGpDA;EACI,cAAA;EACA,gBAAA;AHuDJ;;AGpDA;EACI,cAAA;AHuDJ;;AGrDA;EACI,yBAAA;AHwDJ;;AGtDA;EACI,yBAAA;AHyDJ;;AGvDA;EACI,yBAAA;AH0DJ;;AGxDA;EACI,yBAAA;AH2DJ;;AGzDA;EACI,yBAAA;AH4DJ;;AInJA,8BAAA;AACA;;EAEI,iBAAA;EACA,kBAAA;AJsJJ;;AIpJA;EACE,cH8B2B;ADyH7B;AIrJE;EACG,cH6BwB;EG5BxB,qBAAA;AJuJL;;AInJA;;;;;;;;EAQI,UAAA;AJsJJ;;AIpJA;;;EAGI,qBAAA;AJuJJ;;AIpJA,sCAAA;AACA;;;;;ECJI,4BAAA;ALoKJ;;AIxJA;;ECZI,6BAAA;AL6KJ;;AI5JA;ECjBI,6BAAA;ALqLJ;;AIjKA;EACI,WAAA;EACA,kBAAA;AJoKJ;;AIlKA;EACI,gBAAA;AJqKJ;;AIlKA;EACI,kBAAA;EACA,MAAA;EACA,aAAA;AJqKJ;;AI/JI;EACI,kCAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AJkKR;AIhKI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AJkKR;AIhKI;EACI,6GAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AJkKR;;AI9JA;;;EAGI,aAAA;AJiKJ;;AI9JA;EACI,UAAA;AJiKJ;;AI/JA;EACI,iBAAA;EACA,aAAA;AJkKJ;;AIhKA;EACI,WAAA;AJmKJ;;AM7QA;;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;ANgRJ;AM9QI;;EACI,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;ANiRR;AM9QI;;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;ANiRR;AM9QI;;EACI,2BAAA;EACA,iDAAA;EACA,kBAAA;EACA,UAAA;ANiRR;AM/QQ;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cLtCiB;EKuCjB,iBAAA;EACA,2DAAA;ANkRZ;AM/QQ;;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eLqDmB;EKpDnB,cLhDiB;EKiDjB,kBAAA;EACA,gBLgEiB;EK/DjB,iBAAA;ANkRZ;AM9QI;;EACI,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;ANiRR;AM/QQ;;EACI,WAAA;EACA,YAAA;ANkRZ;AM9QI;;EACI,gBAAA;EACA,WAAA;EACA,cAAA;ANiRR;AM9QY;;EACI,cL7Ea;EK8Eb,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;ANiRhB;AM/QgB;;EACI,qCAAA;EACA,UAAA;ANkRpB;AM/QgB;;EACI,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;ANkRpB;AM/QgB;;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ANkRpB;AM9QY;;EACI,qCAAA;EACA,UAAA;ANiRhB;AM9QY;;EACI,cLlHa;EKmHb,UAAA;EACA,qCAAA;ANiRhB;AM7QY;;EACI,cAAA;EACA,iDAAA;ANgRhB;AM9QgB;;EACI,gBAAA;ANiRpB;AMzQQ;;EACI,gBAAA;EACA,kBAAA;EACA,WAAA;AN4QZ;AMzQQ;;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AN4QZ;AM1QY;;EACI,yBAAA;AN6QhB;AMxQQ;;EACI,cLvJiB;EKwJjB,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AN2QZ;AMvQI;;EACI,kBLfyB;EKgBzB,iDAAA;AN0QR;AMxQQ;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cL1KiB;EK2KjB,iBAAA;EACA,2DAAA;AN2QZ;AMxQQ;;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eL/EmB;EKgFnB,cLpLiB;EKqLjB,kBAAA;EACA,gBLpEiB;EKqEjB,iBAAA;AN2QZ;AMvQI;;EACI,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AN0QR;AMxQQ;;EACI,WAAA;EACA,YAAA;AN2QZ;AMvQI;;;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AN0QR;AMvQI;;EACI,aAAA;EACA,mBAAA;AN0QR;AMvQI;;EDnJA,mBJmKkB;EI7JlB,gEAAA;EACA,0BAAA;EC8IG,UAAA;EACA,UAAA;ANiRP;AM9QI;;;EAEI,aAAA;ANiRR;AM9QI;;ED9JA,mBJrDyB;EI2DzB,gEAAA;EACA,0BAAA;ALgbJ;AMtRI;;EDjKA,mBJuKkB;EIjKlB,gEAAA;EACA,0BAAA;AL2bJ;AM9RI;;EDpKA,mBJkKkB;EI5JlB,gEAAA;EACA,0BAAA;ALscJ;AMtSI;;EDvKA,mBJqKkB;EI/JlB,gEAAA;EACA,0BAAA;ALidJ;AM9SI;;ED1KA,mBJsKkB;EIhKlB,gEAAA;EACA,0BAAA;AL4dJ;AMtTI;;ED7KA,mBJoKkB;EI9JlB,gEAAA;EACA,0BAAA;ALueJ;AM9TI;;EDhLA,mBJmKkB;EI7JlB,gEAAA;EACA,0BAAA;ALkfJ;;AMnUA;EACI,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,yBLxI0B;EKyI1B,gBAAA;ANsUJ;AMpUI;EACI,kBAAA;EACA,8BAAA;ANsUR;AMnUI;EACI,6BAAA;ANqUR;AMlUI;EACI,gBAAA;ANoUR;;AMhUA;;EAEI,cAAA;EACA,gBAAA;EACA,YAAA;EAEA,gCAAA;EAEA,+BAAA;EAEA,0CAAA;EACA,iCAAA;ANmUJ;;AM5TQ;EDzOJ,4CAAA;EC2OQ,mBAAA;ANmUZ;AMlUY;EACI,6BAAA;ANoUhB;AMlUY;EACI,2BAAA;ANoUhB;AMjUgB;EACI,eAAA;ANmUpB;AMjUY;EDtPR,2CAAA;ECwPY,qBAAA;EACA,uBAAA;ANuUhB;;AM9TA;ED1QQ,4CAAA;EC4QJ,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,qBAAA;ANqUJ;;AMnUA;EACI,UAAA;EDlRI,2CAAA;ECoRJ,qBAAA;EACA,uBAAA;AN0UJ;;AMvUA;;EAEI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;AN0UJ;;AMvUA;EACI,0CAAA;EACA,0CAAA;EACA,uCAAA;EACA,YAAA;AN0UJ;;AMvUA;EACI,0CAAA;EACA,4BAAA;EACA,uCAAA;EACA,YAAA;AN0UJ;;AMrUQ;EAGI,4BAAA;ANwUZ;AMpUQ;EACI,gBAAA;EACA,cAAA;ANsUZ;AMlUQ;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;ANoUZ;AMlUY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ANoUhB;AMlUgB;EACI,eAAA;EACA,iBAAA;ANoUpB;AM/TQ;EACI,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;ANiUZ;AM9TQ;EACI,cAAA;ANgUZ;AM7TQ;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,8BAAA;AN+TZ;AM7TY;EACI,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AN+ThB;AM7TgB;EAEI,qBAAA;AN8TpB;;AO7uBA;EACI,iBNKyB;EMJzB,6BNqByB;EMpBzB,gBNuHyB;EOvH3B,YDEmB;ECCnB,yBAAA;EDAE,iBAAA;EEJF,qBRuB2B;EQtB3B,cRsB2B;AD+tB7B;ASnvBE;EAKE,6BRayB;EQZzB,cRgByB;EQfzB,qBReyB;ADkuB7B;AS1uBI;EAME,6BRFuB;EQGnB,qBRDmB;ADwuB7B;ASluBE;EACE,cRxByB;EQyBzB,yBRRyB;EOtB3B,UC+BmB;ED5BnB,0BAAA;ARiwBF;ASnuBI;EAKI,yBRdqB;EQerB,cRlCqB;ADmwB7B;AS9tBI;EACI,yBRtCqB;ADswB7B;AS5tBE;EACI,yBR1BuB;ADwvB7B;AOvwBI;ECPF,UDSuB;ECNvB,0BAAA;EDOM,qBAAA;EACA,gBAAA;APywBR;AOvwBI;EFJM,gBEOD;EACA,qBAAA;APwwBT;AOrwBI;EACI,YN0CwB;AD6tBhC;;AOhwBA;EE7BE,qBR2B2B;EQ1B3B,cR0B2B;ADuwB7B;AS/xBE;EAKE,6BRayB;EQZzB,cRoByB;EQnBzB,qBRmByB;AD0wB7B;AStxBI;EAME,6BRFuB;EQGnB,qBRGmB;ADgxB7B;AS9wBE;EACE,cRxByB;EQyBzB,yBRJyB;EO1B3B,UC+BmB;ED5BnB,0BAAA;AR6yBF;AS/wBI;EAKI,yBRVqB;EQWrB,cRlCqB;AD+yB7B;AS1wBI;EACI,yBRtCqB;ADkzB7B;ASxwBE;EACI,yBRtBuB;ADgyB7B;;AO7xBA;EE9BE,qBR+B2B;EQ9B3B,cR8B2B;ADiyB7B;AS7zBE;EAKE,6BRayB;EQZzB,cRwByB;EQvBzB,qBRuByB;ADoyB7B;ASpzBI;EAME,6BRFuB;EQGnB,qBROmB;AD0yB7B;AS5yBE;EACE,cRxByB;EQyBzB,yBAAA;ED9BF,UC+BmB;ED5BnB,0BAAA;AR20BF;AS7yBI;EAKI,yBRNqB;EQOrB,cRlCqB;AD60B7B;ASxyBI;EACI,yBRtCqB;ADg1B7B;AStyBE;EACI,yBRlBuB;AD0zB7B;;AO1zBA;EE/BE,qBRmC2B;EQlC3B,cRkC2B;AD2zB7B;AS31BE;EAKE,6BRayB;EQZzB,cR4ByB;EQ3BzB,qBR2ByB;AD8zB7B;ASl1BI;EAME,6BRFuB;EQGnB,qBRWmB;ADo0B7B;AS10BE;EACE,cRxByB;EQyBzB,yBRIyB;EOlC3B,UC+BmB;ED5BnB,0BAAA;ARy2BF;AS30BI;EAKI,yBRFqB;EQGrB,cRlCqB;AD22B7B;ASt0BI;EACI,yBRtCqB;AD82B7B;ASp0BE;EACI,yBRduB;ADo1B7B;;AOv1BA;EEhCE,qBRuC2B;EQtC3B,cRsC2B;ADq1B7B;ASz3BE;EAKE,6BRayB;EQZzB,cRgCyB;EQ/BzB,qBR+ByB;ADw1B7B;ASh3BI;EAME,6BRFuB;EQGnB,qBRemB;AD81B7B;ASx2BE;EACE,cRxByB;EQyBzB,yBRQyB;EOtC3B,UC+BmB;ED5BnB,0BAAA;ARu4BF;ASz2BI;EAKI,yBREqB;EQDrB,cRlCqB;ADy4B7B;ASp2BI;EACI,yBRtCqB;AD44B7B;ASl2BE;EACI,yBRVuB;AD82B7B;;AOp3BA;EEjCE,qBR4C2B;EQ3C3B,cR2C2B;AD82B7B;ASv5BE;EAKE,6BRayB;EQZzB,cRqCyB;EQpCzB,qBRoCyB;ADi3B7B;AS94BI;EAME,6BRFuB;EQGnB,qBRoBmB;ADu3B7B;ASt4BE;EACE,cRxByB;EQyBzB,yBRayB;EO3C3B,UC+BmB;ED5BnB,0BAAA;ARq6BF;ASv4BI;EAKI,yBROqB;EQNrB,cRlCqB;ADu6B7B;ASl4BI;EACI,yBRtCqB;AD06B7B;ASh4BE;EACI,yBRLuB;ADu4B7B;;AOj5BA;EElCE,qBRM2B;EQL3B,cRK2B;ADk7B7B;ASr7BE;EAKE,6BRayB;EQZzB,cRHyB;EQIzB,qBRJyB;ADu7B7B;AS56BI;EAME,6BRFuB;EQGnB,qBRlBmB;AD27B7B;ASp6BE;EACE,cRxByB;EQyBzB,yBRzByB;EOL3B,UC+BmB;ED5BnB,0BAAA;ARm8BF;ASr6BI;EAKI,yBRjCqB;EQkCrB,cRlCqB;ADq8B7B;ASh6BI;EACI,yBRtCqB;ADw8B7B;AS95BE;EACI,yBR3CuB;AD28B7B;AO56BI;EAGK,yBNlCoB;EMmCpB,cNlBoB;AD87B7B;AOz6BI;EAGI,cNxBqB;ADi8B7B;AOt6BI;EAEI,6BAAA;APu6BR;;AOl6BK;ECxDH,YD2DuB;ECxDvB,yBAAA;AR49BF;;AOj6BA;EACI,iBN7DyB;EM8DzB,8BAAA;EACA,iBAAA;APo6BJ;AOl6BI;EACI,YNFwB;ADs6BhC;;AOj6BA;EACI,SNvEyB;EMwEzB,eN+B2B;EM9B3B,iBAAA;APo6BJ;AOl6BI;EACI,YNdwB;ADk7BhC;;AOj6BA;EE1BG,eRmD4B;EQlD5B,kBRqC6B;EQpC7B,kBAAA;EF0BA,gBNqC0B;ADi4B7B;AS97BG;EACI,kBAAA;ATg8BP;AS77BG;EACI,kBAAA;AT+7BP;;AO16BA;EE9BG,eRiD4B;EQhD5B,kBRmC6B;EQlC7B,iBAAA;AT48BH;AS18BG;EACI,iBAAA;AT48BP;ASz8BG;EACI,iBAAA;AT28BP;;AOn7BA;EEjCG,eRiD4B;EQhD5B,kBRmC6B;EQlC7B,gBAAA;ATw9BH;ASt9BG;EACI,gBAAA;ATw9BP;ASr9BG;EACI,gBAAA;ATu9BP;;AO57BA;EACI,gBAAA;AP+7BJ;;AO57BA;EACI,WAAA;AP+7BJ;;AO77BA;EACI,gBAAA;APg8BJ;;AO97BA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;APi8BJ;;AO/7BA;EACI,aAAA;APk8BJ;;AO/7BA;EACI,qBN4GgB;EM3GhB,cN2GgB;ADu1BpB;AOj8BI;EACI,qBAAA;EACA,qBNwGY;EMvGZ,cNuGY;AD41BpB;;AOh8BA;EACI,qBNkGiB;EMjGjB,cNiGiB;ADk2BrB;AOj8BI;EACI,qBAAA;EACA,qBN6Fa;EM5Fb,cN4Fa;ADu2BrB;;AUpkCA;ECMG,cVa0B;EOhB3B,UGIkB;EHDlB,0BAAA;ARokCF;;AUvkCA;ECGG,cVa0B;EOhB3B,UGIkB;EHDlB,0BAAA;AR0kCF;;AU1kCA;ECAG,cVa0B;EOhB3B,UGIkB;EHDlB,0BAAA;ARglCF;;AU7kCA;ECHG,cVa0B;EOhB3B,UGIkB;EHDlB,0BAAA;ARslCF;;AU/kCA;EACI,yBTLyB;ESMzB,yBAAA;EACA,kBT8E4B;ES7E5B,cAAA;EChBA,iBAAA;EACA,YVqG2B;EI3FrB,gBKON;AVolCJ;AUllCI;EACO,yBTbkB;ESclB,yBAAA;ELXD,gBKYC;EACA,qBAAA;EACA,cAAA;AVqlCX;AUllCI;EAII,qBTfqB;EINnB,gBKsBF;AVklCR;AU/kCI;EACI,cTLqB;ADslC7B;AU/kCI;EACI,qBTRqB;ADylC7B;AU/kCI;EACI,cTEqB;AD+kC7B;AU/kCI;EACI,qBTDqB;ADklC7B;AU9kCI;EACI,kBT4CwB;ES3CxB,eTqDuB;ESpDvB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AVglCR;AU7kCI;EACI,0BAAA;EACA,gCAAA;AV+kCR;;AU3kCA;EACI,YAAA;EACA,kBAAA;AV8kCJ;;AU1kCI;EACI,cT3BqB;ADwmC7B;;AUzkCI;EACI,cT7CqB;ADynC7B;;AUvkCA;EACI,yBT5EyB;ES6EzB,yBAAA;EACA,kBTQ4B;ADkkChC;AUxkCI;EAEI,yBTlFqB;ESmFrB,yBAAA;AVykCR;AUvkCI;EACI,qBThDqB;ESiDrB,cTjDqB;AD0nC7B;AUvkCI;EACI,qBTjEqB;ESkErB,cTlEqB;AD2oC7B;AUvkCI;EAEI,yBT/FqB;ESgGrB,qBTnFqB;AD2pC7B;;AUpkCA;;;;EAII,oBAAA;AVukCJ;;AUrkCA;;;;EAII,mBAAA;AVwkCJ;;AUtkCA;EACI,yBT9GyB;ES+GzB,cTjGyB;ESkGzB,mBAAA;AVykCJ;;AUtkCA;EACI,iBT1HyB;ES2HzB,iBAAA;AVykCJ;;AUvkCA;EACI,qBThHyB;AD0rC7B;;AUvkCA;EACI,cAAA;AV0kCJ;;AUvkCA;EACI,qBTtHyB;ADgsC7B;;AYrtCA;EACI,SAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AZwtCJ;AYttCI;EACI,kBAAA;AZwtCR;AYrtCI;EACI,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AZutCR;AYrtCI;EACI,SAAA;AZutCR;AYptCI;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AZstCR;AYntCI;EACI,0BAAA;EACA,8CAAA;AZqtCR;AYltCI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AZotCR;AYltCQ;EACI,aAAA;AZotCZ;AYhtCI;EACI,cAAA;EACA,cAAA;AZktCR;AY/sCI;EACI,4BAAA;EACA,kBX0BwB;ADurChC;AY9sCI;EACI,kBAAA;AZgtCR;;AY7sCA;EACI,yBXsLwB;AD0hC5B;;AY9sCA;EACK,yBXoLuB;AD6hC5B;;AY/sCA;EACI,yBXkLwB;ADgiC5B;;AYhtCA;EACK,yBXgLuB;ADmiC5B;;AYjtCA;EACK,yBX8KuB;ADsiC5B;;Aa1yCG;;EAEK,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;Ab6yCR;Aa3yCQ;;EACI,SAAA;Ab8yCZ;Aa3yCG;;;;;;EAMI,iBAAA;EACA,sBAAA;Ab6yCP;Aa1yCI;EACI,wBAAA;EACA,eZ8EuB;EY7EvB,yBAAA;EACA,cZTqB;EYUrB,gBZ2FqB;EY1FrB,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;Ab4yCR;AazyCG;ELnCD,aKoCuB;ELjCvB,yBAAA;AR60CF;Aa1yCQ;EACI,iBAAA;EACA,kBAAA;Ab4yCZ;AazyCI;EACI,eAAA;Ab2yCR;AaxyCI;EACI,kBAAA;Ab0yCR;AavyCY;ELnDV,UKoD+B;ELjD/B,0BAAA;AR21CF;AaryCI;EACI,2BAAA;AbuyCR;;AajyCY;EACI,WAAA;AboyChB;;Aa9xCA;EACI,iBAAA;AbiyCJ;;Ac52CA;;EAEI,mBAAA;EACA,kBAAA;Ad+2CJ;;Ac32CI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;Ad82CR;Ac32CI;;EAEI,kCAAA;EACA,gBAAA;EACA,cbIqB;EaHrB,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;Ad62CR;Ac32CI;EACI,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,cbCqB;EaArB,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;Ad62CR;Ac32CI;EACI,kBAAA;Ad62CR;Ac12CQ;EACI,cb1BiB;Ea2BjB,YAAA;EACA,mBAAA;Ad42CZ;;Acp2CQ;EACI,kBAAA;Adu2CZ;;Acl2CA;;;;EAII,WAAA;EACA,oBAAA;Adq2CJ;;Acl2CA;EACI,mBAAA;Adq2CJ;;Acl2CA;;EAEI,UAAA;EACA,kBAAA;EACA,kBAAA;Adq2CJ;;Acn2CA;EACI,UAAA;Ads2CJ;;Acn2CA;EACI,UAAA;Ads2CJ;;Acn2CA;;EAEI,mBAAA;Ads2CJ;;Acn2CA;;EAEI,+BAAA;Ads2CJ;;Acn2CA;EACI,qBAAA;Ads2CJ;;Acj2CI;EACI,oBAAA;Ado2CR;Acj2CQ;EACI,cbzFiB;Ea0FjB,YAAA;EACA,mBAAA;Adm2CZ;;Ac91CA;EACI,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;Adi2CJ;;Ac91CA;;EAEI,UAAA;EACA,+BAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;Adi2CJ;;Ac91CA;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;Adi2CJ;;Ac91CA;EACI,UAAA;EACA,+BAAA;Adi2CJ;;Ac91CA;EACI,UAAA;EACA,+BAAA;Adi2CJ;;Ac91CA;;EAEI,cb1IyB;AD2+C7B;;Ac11CY;EACI,6BAAA;Ad61ChB;;AelgDQ;;EAEI,6BAAA;AfqgDZ;;AehgDA;EACI,SdNyB;EcOzB,ed2G2B;Ec1G3B,gBAAA;EACA,gBAAA;EACA,2CdmPwB;EclPxB,2CAAA;AfmgDJ;AejgDI;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cdIqB;AD+/C7B;AejgDQ;EACI,cAAA;AfmgDZ;AehgDI;EACI,sBAAA;EACA,UAAA;EACA,eAAA;AfkgDR;AehgDQ;EACI,kBAAA;EACA,OAAA;EACA,eAAA;AfkgDZ;Ae//CQ;EACI,gBAAA;EACA,SAAA;AfigDZ;Ae9/CQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AfggDZ;Ae9/CQ;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AfggDZ;Aez/CY;EACI,cdvCa;EcwCb,kBd2FiB;Ec1FjB,gBd2FiB;Ec1FjB,kBAAA;EACA,oBAAA;EACA,iBAAA;Af2/ChB;Aez/CgB;EACI,gBdyFa;EcxFb,iBAAA;Af2/CpB;Aex/CgB;EACI,gBdqFa;ADq6CjC;Aev/CgB;EAMI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;Afo/CpB;Aej/CgB;EACI,cdxDS;AD2iD7B;Ae/+CY;EACI,mBdFe;EcGf,gBAAA;Afi/ChB;Ae9+CoB;EACI,4BAAA;EACA,6BAAA;Afg/CxB;Ae9+CoB;EACI,+BAAA;EACA,gCAAA;Afg/CxB;Ae5+CgB;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;Af8+CpB;Aez+CQ;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,cd1HiB;Ec2HjB,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,SAAA;Af2+CZ;Aex+CQ;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;Af0+CZ;Aev+CI;EACG,gBdqB0B;EcpB1B,ed/CwB;ADwhD/B;Aev+CI;EACI,edhDuB;ADyhD/B;Aet+CI;EACI,sCAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;Afw+CR;Aer+CI;EACI,gBAAA;EACA,gBAAA;Afu+CR;;Ael+CI;EACI,cdrKqB;EOL3B,YO2KuB;EPxKvB,yBAAA;AR8oDF;Aep+CQ;EAEI,6BAAA;EP/KV,UOgL2B;EP7K3B,0BAAA;EO8KU,cd5KiB;ADkpD7B;Aeh+CY;EACI,cdnLa;EcoLb,qBdpLa;EOL3B,YO0L+B;EPvL/B,yBAAA;AR0pDF;Ae79CY;;;;;;;;;;;EAGI,6BAAA;EACA,kBAAA;EACA,cdhMa;EOL3B,UOsM+B;EPnM/B,0BAAA;AR2qDF;Aep+CQ;EACI,6BAAA;Afs+CZ;Ael+CY;;;;;EAGI,6BAAA;EACA,cd9Ma;EOL3B,UOoN+B;EPjN/B,0BAAA;ARwrDF;Ael+CI;EACI,cdrNqB;EcsNrB,qBdtNqB;AD0rD7B;Ael+CI;EACI,cd5MqB;Ec6MrB,yBd1NqB;EOL3B,YOgOuB;EP7NvB,yBAAA;ARksDF;Aen+CI;;;;;;;;;EAKI,qBdlOqB;EOL3B,UOwOuB;EPrOvB,0BAAA;AR+sDF;;Aer+CI;EACI,0CAAA;Afw+CR;;Aen+CA;EACI,2CdUwB;EcTxB,2CAAA;Afs+CJ;Ael+CY;EACI,cdxOa;AD4sD7B;Aeh+CQ;;;;;EAKI,6BAAA;EACA,kBAAA;EACA,cdnOiB;EOlC3B,UOsQ2B;EPnQ3B,0BAAA;ARsuDF;Ae/9CY;;;EAGI,6BAAA;EACA,cd5Oa;AD6sD7B;Ae59CQ;EACI,6BAAA;Af89CZ;Aez9CI;EACI,cdxPqB;EcyPrB,qBdzPqB;ADotD7B;Aez9CI;EAGQ,cd9QiB;ADuuD7B;;Aer9CA,sCAAA;AAGI;EACI,gBAAA;EACA,mBAAA;Afs9CR;Ael9CY;EACI,kBAAA;EACA,iBd9IiB;Ec+IjB,ed9IiB;ADkmDjC;Aeh9CQ;EACI,eAAA;EACA,kBAAA;Afk9CZ;Aeh9CQ;EACI,eAAA;Afk9CZ;;Ae78CA;EVrTU,gBUsTP;Afi9CH;Aeh9CG;EJxTC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EIuTI,YAAA;EACA,edhNuB;EciNvB,gBdzMuB;Ec0MvB,cdtTqB;AD2wD7B;Aen9CI;EAEI,cdpUqB;EcqUrB,SdzUqB;Ec0UrB,iDAAA;Afo9CR;;Ae/8CA;EClVI,yBfiQwB;ADoiD5B;;Aeh9CA;ECrVI,yBfkQwB;ADuiD5B;;Aej9CA;ECxVI,yBfmQwB;AD0iD5B;;Ael9CA;EC3VI,yBfoQwB;AD6iD5B;;Aen9CA;EC9VI,yBfqQwB;ADgjD5B;;Aen9CA;EACI,iBAAA;EACA,6BAAA;EACA,oCAAA;Afs9CJ;;Aen9CA;EACI,gBAAA;EACA,mBAAA;EACA,SdxWyB;AD8zD7B;Aep9CI;EACI,yBdvWqB;AD6zD7B;Aep9CK;;EAEG,yBAAA;Afs9CR;Aen9CI;EAEI,6BAAA;Afo9CR;;AiB50DA;EACI,yBhBOyB;ADw0D7B;AiB70DI;EACI,YAAA;AjB+0DR;AiB50DI;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AjB80DR;AiB50DQ;EACI,chBOiB;EgBNjB,cAAA;EACA,kBAAA;AjB80DZ;AiB70DY;EAEI,chBQa;ADs0D7B;AiB10DI;EACI,eAAA;AjB40DR;AiB30DQ;EACI,oBAAA;AjB60DZ;AiB10DI;EACG,chBTsB;EgBUtB,qBAAA;EACA,mBAAA;EACA,iBhB8H0B;EgB7H1B,ehB2EwB;EgB1ExB,mBAAA;EACA,iBhB2FuB;EgB1FvB,kBAAA;AjB40DP;AiB30DO;EAEI,chBbkB;ADy1D7B;AiBz0DI;EACI,chBjBqB;EgBkBrB,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,ehByDuB;ADkxD/B;AiBz0DI;EACI,qBhBhCqB;AD22D7B;AiBz0DI;EACI,chB3BqB;ADs2D7B;;AiBv0DA;EACI,yBhBhDyB;AD03D7B;;AiBt0DI;EACG,ehByCwB;ADgyD/B;AiBx0DO;EACK,iBAAA;EACA,WAAA;AjB00DZ;AiBx0DQ;EACI,iBAAA;EACA,0BAAA;AjB00DZ;;AkB/2DA;;;;;CAAA;AAOA;EAEE,sBAAA;EAEA,yBAAA;AlBi3DF;;AkB92DA;EAEE,mCAAA;AlBi3DF;;AkB92DA;EAEE,sBAAA;AlBi3DF;;AkB92DA;;EAGE,yBAAA;AlBi3DF;;AkB92DA;;EAGE,yBAAA;AlBi3DF;AkB71DA;EACE;IAEE,+BAAA;ElB82DF;EkB32DA;IAEE,mCAAA;ElB62DF;EkB12DA;IAEE,kCAAA;ElB42DF;AACF;AkBz2DA;EAEE,qBAAA;AlB22DF;AkBx1DA;EACE;IACE,UAAA;IAEA,mCAAA;ElBu2DF;EkBp2DA;IACE,UAAA;IAEA,eAAA;ElBs2DF;AACF;AkBn2DA;EAEE,0BAAA;AlBq2DF;AkBv1DA;EACE;IACE,UAAA;ElBk2DF;EkB/1DA;IACE,UAAA;ElBi2DF;AACF;AkB91DA;EAEE,uBAAA;AlBg2DF;AkBj1DA;EACE;IACE,UAAA;ElB81DF;EkB31DA;IACE,UAAA;IAEA,kCAAA;ElB61DF;AACF;AkB11DA;EAEE,2BAAA;AlB41DF;AkB70DA;EACE;IACE,UAAA;ElB01DF;EkBv1DA;IACE,UAAA;IAEA,mCAAA;ElBy1DF;AACF;AkBt1DA;EAEE,yBAAA;AlBw1DF;;AmBzjEA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBlB4F2B;EkB3F3B,cAAA;EACA,aAAA;EACA,kBAAA;EXJF,UWMmB;EXHnB,wBAAA;EHMQ,4CcFN;AnB6jEJ;AmB3jEI;EXTF,UWUuB;EXPvB,0BAAA;EWQM,mBAAA;AnB8jER;AmB5jEI;EACG,4BlBqHoB;EI1HjB,gBcMH;Ed0DC,2BJuEqB;EI/GrB,mBAAA;EARJ,4BAAA;EcNG,iBAAA;AnB2kEP;AmBzkEI;EACI,gBAAA;AnB2kER;AmBxkEI;EACG,iBAAA;EACA,cAAA;AnB0kEP;AmBxkEO;EACI,gBAAA;AnB0kEX;AmBvkEI;EACI,qBAAA;AnBykER;AmBtkEI;EACI,eAAA;AnBwkER;AmBrkEI;EACG,4BlBmDwB;EkBlDxB,6BlBkDwB;ADqhE/B;AmBpkEI;EACI,+BlB8CuB;EkB7CvB,gClB6CuB;ADyhE/B;AmBnkEI;EACI,gBAAA;EACA,qBAAA;AnBqkER;AmBlkEI;;EAEI,yBlBlDqB;EkBmDrB,cAAA;EACA,UAAA;EACA,qBAAA;AnBokER;AmBjkEI;EAEI,yClBbqB;AD+kE7B;AmBhkEI;EAEI,yClBhBqB;ADilE7B;AmB/jEI;EAEI,yClBnBqB;ADmlE7B;AmB9jEI;EAEI,wClBtBqB;ADqlE7B;AmB7jEI;EAEI,wClBzBqB;ADulE7B;AmB1jEQ;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AnB4jEZ;AmBvjEQ;EAEI,sBAAA;EACA,qBAAA;AnBwjEZ;;AmBjjEI;EACI,iBAAA;EACA,iBAAA;AnBojER;AmBljEI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;AnBojER;AmBljEQ;EACK,eAAA;EACA,WAAA;AnBojEb;AmBljEQ;EAOI,eAAA;EACA,WAAA;AnB8iEZ;;AmBxiEA;EACI,gBAAA;AnB2iEJ;;AmBziEA;EACI,iBAAA;AnB4iEJ;;AoBxrEA;EACI,kBnB6F4B;EmB5F5B,yBnBMyB;EmBLzB,mBAAA;ApB2rEJ;AoBzrEI;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EAGA,4BAAA;ApB2rER;AoBzrEQ;EACI,WAAA;ApB2rEZ;AoBxrEI;EACI,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EZxBN,UY0BuB;EZvBvB,wBAAA;ARitEF;AoBxrEQ;EfuEN,kBAAA;EACA,QAAA;EAGA,2BAAA;ALonEF;AoB3rEI;EZhCF,UYiCuB;EZ9BvB,0BAAA;AR4tEF;AoB5rEI;EZnCF,UYoCuB;EZjCvB,wBAAA;ARguEF;AoB7rEI;EZtCF,UYuCuB;EZpCvB,0BAAA;ARouEF;AoB9rEI;EACI,4BAAA;ApBgsER;AoB9rEI;EACI,oBAAA;EACA,yBnBzCqB;EmB0CrB,8BAAA;ApBgsER;AoB7rEI;;EAEI,enBkDuB;EmBjDvB,gBnBkEqB;EmBjErB,cnBpCqB;EmBqCrB,kBAAA;ApB+rER;AoB7rEQ;;EACI,enBwDmB;ADwoE/B;AoB5rEI;EACI,enBwCuB;EmBvCvB,kBAAA;EACA,yBAAA;ApB8rER;AoB3rEI;EACI,SnBpEqB;EmBqErB,cnB1DqB;EmB2DrB,gBnB+CqB;AD8oE7B;AoB3rEI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;ApB6rER;AoB3rEI;EACI,enBqBuB;EmBpBvB,WAAA;ApB6rER;AoB3rEI;EACI,cAAA;EACA,6BnBlEqB;EmBmErB,iBAAA;EACA,2BAAA;EACA,eAAA;ApB6rER;AoB3rEQ;EACI,cAAA;ApB6rEZ;AoB1rEQ;EACI,eAAA;EACA,kBAAA;ApB4rEZ;AoBzrEI;EACI,cAAA;ApB2rER;AoBzrEI;EACI,qBAAA;ApB2rER;AoBxrEI;EACI,enBLuB;EmBMvB,gBnBYqB;EmBXrB,yBAAA;ApB0rER;AoBxrEI;EACI,enBXuB;ADqsE/B;AoBxrEI;EACI,enBbuB;EmBcvB,SAAA;ApB0rER;AoBxrEI;EACI,YAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;EACA,yBnB5GqB;EmB6GrB,aAAA;EACA,kBAAA;ApB0rER;AoBvrEI;EACI,mBAAA;EACA,aAAA;ApByrER;AoBtrEI;EACI,0BAAA;ApBwrER;AoBprEQ;;EAEI,kBAAA;ApBsrEZ;AoBnrEQ;;EAEI,mBAAA;ApBqrEZ;AoBjrEI;EACI,kBnB5DwB;EmB6DxB,kBAAA;ApBmrER;AoBjrEQ;EACI,kBAAA;ApBmrEZ;;AoB3qEI;EACI,sBAAA;ApB8qER;AoB5qEQ;EACI,iBAAA;EACA,iBAAA;ApB8qEZ;AoB5qEY;EACI,gBAAA;ApB8qEhB;AoB1qEI;EACI,2BAAA;ApB4qER;AoBxqEI;EACI,cAAA;EACA,gBAAA;ApB0qER;AoBxqEQ;EACI,gBAAA;EACA,iBAAA;ApB0qEZ;;AoBlqEI;EACI,aAAA;ApBqqER;AoBnqEI;EACI,SAAA;EACA,iBAAA;ApBqqER;AoBnqEI;EACI,kBAAA;EACA,oBAAA;EACA,iBAAA;ApBqqER;AoBnqEI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;ApBqqER;AoBnqEQ;EACI,qBAAA;ApBqqEZ;AoBlqEI;EACI,iBAAA;ApBoqER;AoBlqEI;EACI,iBAAA;ApBoqER;;AoB9pEI;;EACI,sBAAA;ApBkqER;AoBhqEI;;EACI,gBAAA;ApBmqER;;AoBhqEA;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;ApBmqEJ;AoBjqEI;EACI,kBAAA;ApBmqER;;AoB/pEA;EACI,uBAAA;ApBkqEJ;AoBhqEI;EACI,wCAAA;ApBkqER;;AqB3yEE;EAxDA,wBC7Bc;ED8Bd,yBC9Bc;ED+Bd,iBC9Ba;ED+Bb,cC5BoB;AtBm4EtB;;AqB9yEE;;EArEA,cAAA;EAKA,aAAA;ArBw3EF;;AqBnzEE;EA3FA,qBA4F4B;EAxF5B,2BAwFsC;EArFpC,gBAAA;EAuFA,kBAAA;ArB6zEJ;;AqB1zEE;EAjGA,uBAkG4B;EA9F5B,2BA8FwC;EA3FtC,gBAAA;EA6FA,kBAAA;ArBo0EJ;;AqBj0EE;EAvGA,qBAwG4B;EApG5B,yBAoGsC;EA/FpC,iBAAA;EAiGA,gBAAA;ArB20EJ;;AqBx0EE;EA7GA,qBA8G4B;EA1G5B,2BA0GsC;EAvGpC,gBAAA;EAyGA,kBAAA;ArBk1EJ;;AqB/0EE;EAnHA,qBAoH4B;EAhH5B,uBAgHsC;EAzGpC,kBAAA;EA2GA,kBAAA;ArBy1EJ;;AqBt1EE;EAzHA,uBA0H4B;EAtH5B,uBAsHwC;EA/GtC,kBAAA;EAiHA,kBAAA;ArBg2EJ;;AqB71EE;EA/HA,qBAgI4B;EA5H5B,2BA4HsC;EAzHpC,gBAAA;EA2HA,kBAAA;ArBu2EJ;;AqBp2EE;EArIA,uBAsI4B;EAlI5B,2BAkIwC;EA/HtC,gBAAA;EAiIA,kBAAA;ArB82EJ;;AqB32EE;EA3IA,mBA6I4B;EAzI5B,yBAyIoC;EApIlC,iBAAA;EAsIA,gBAAA;ArBo3EJ;;AqBj3EE;EAlJA,mBAmJ4B;EA/I5B,2BA+IoC;EA5IlC,gBAAA;EA8IA,gBAAA;ArB23EJ;;AqBx3EE;EAvHA,0BC7Bc;ED8Bd,iBC5Bc;ED+BZ,qBChCgB;AtBihFpB;;AqB13EE;EAlHA,iBC/Bc;EDgCd,qBC9Be;AtB8gFjB;;AqB33EE;EAjHA,UAAA;EACA,iBCvCc;AtBuhFhB;;AqB53EE;EA5GA,YAAA;EACA,iBC1CgB;AtBshFlB;;AqB73EE;EA3GA,UAAA;EACA,kBC5Ca;AtBwhFf;;AqB93EE;EA1GA,UAAA;EACA,kBC9Ce;AtB0hFjB;;AqBx+EE;EACE,eA2GY;ArBg4EhB;AqBx+EE;EACE,aAuGY;ArBm4EhB;;AqB/+EE;EACE,eA2GY;ArBu4EhB;AqB/+EE;EACE,aAuGY;ArB04EhB;;AqBt/EE;EACE,eA2GY;ArB84EhB;AqBt/EE;EACE,aAuGY;ArBi5EhB;;AqB7/EE;EACE,eA2GY;ArBq5EhB;AqB7/EE;EACE,aAuGY;ArBw5EhB;;AqBpgFE;EACE,eA2GY;ArB45EhB;AqBpgFE;EACE,aAuGY;ArB+5EhB;;AqB3gFE;EACE,eA2GY;ArBm6EhB;AqB3gFE;EACE,aAuGY;ArBs6EhB;;AqBlhFE;EACE,eA2GY;ArB06EhB;AqBlhFE;EACE,aAuGY;ArB66EhB;;AqBzhFE;EACE,eA2GY;ArBi7EhB;AqBzhFE;EACE,aAuGY;ArBo7EhB;;AqBhiFE;EACE,eA2GY;ArBw7EhB;AqBhiFE;EACE,aAuGY;ArB27EhB;;AqBviFE;EACE,eA2GY;ArB+7EhB;AqBviFE;EACE,aAuGY;ArBk8EhB;;AqB9iFE;EACE,eA2GY;ArBs8EhB;AqB9iFE;EACE,aAuGY;ArBy8EhB;;AqBrjFE;EACE,eA2GY;ArB68EhB;AqBrjFE;EACE,aAuGY;ArBg9EhB;;AqB5jFE;EACE,eA2GY;ArBo9EhB;AqB5jFE;EACE,aAuGY;ArBu9EhB;;AqBnkFE;EACE,eA2GY;ArB29EhB;AqBnkFE;EACE,aAuGY;ArB89EhB;;AqB1kFE;EACE,eA2GY;ArBk+EhB;AqB1kFE;EACE,aAuGY;ArBq+EhB;;AqBx9EM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArB8rF3C;AqBzrFE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;ArB2rFJ;AqBxrFE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArB0rFJ;AqBvrFE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArByrFJ;;AqBj/EM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArButF3C;AqBltFE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;ArBotFJ;AqBjtFE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBmtFJ;AqBhtFE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBktFJ;;AqB1gFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBgvF3C;AqB3uFE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ArB6uFJ;AqB1uFE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArB4uFJ;AqBzuFE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArB2uFJ;;AqBniFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBywF3C;AqBpwFE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ArBswFJ;AqBnwFE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBqwFJ;AqBlwFE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBowFJ;;AqB5jFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBkyF3C;AqB7xFE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ArB+xFJ;AqB5xFE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArB8xFJ;AqB3xFE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArB6xFJ;;AqBrlFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArB2zF3C;AqBtzFE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ArBwzFJ;AqBrzFE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBuzFJ;AqBpzFE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBszFJ;;AqB9mFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBo1F3C;AqB/0FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ArBi1FJ;AqB90FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBg1FJ;AqB70FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArB+0FJ;;AqBvoFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArB62F3C;AqBx2FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;ArB02FJ;AqBv2FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBy2FJ;AqBt2FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBw2FJ;;AqBhqFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBs4F3C;AqBj4FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;ArBm4FJ;AqBh4FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBk4FJ;AqB/3FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBi4FJ;;AqBzrFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArB+5F3C;AqB15FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ArB45FJ;AqBz5FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArB25FJ;AqBx5FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArB05FJ;;AqBltFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBw7F3C;AqBn7FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;ArBq7FJ;AqBl7FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBo7FJ;AqBj7FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBm7FJ;;AqB3uFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBi9F3C;AqB58FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ArB88FJ;AqB38FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArB68FJ;AqB18FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArB48FJ;;AqBpwFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArB0+F3C;AqBr+FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ArBu+FJ;AqBp+FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBs+FJ;AqBn+FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBq+FJ;;AqB7xFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBmgG3C;AqB9/FE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ArBggGJ;AqB7/FE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArB+/FJ;AqB5/FE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArB8/FJ;;AqBtzFM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArB4hG3C;AqBvhGE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;ArByhGJ;AqBthGE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBwhGJ;AqBrhGE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBuhGJ;;AqB/0FM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArBqjG3C;AqBhjGE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ArBkjGJ;AqB/iGE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArBijGJ;AqB9iGE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBgjGJ;;AqBx2FM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ArB8kG3C;AqBzkGE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ArB2kGJ;AqBxkGE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ArB0kGJ;AqBvkGE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ArBykGJ;;AuBjmGA;EACI;IACI,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;EvBomGN;EuBlmGE;IlB6BI,mBAAA;IARJ,sDAAA;ELylGF;EuB1mGE;IlByBI,mBAAA;IAwCA,4BJiEoB;EDo/F1B;EuBhnGE;IACI,YAAA;EvBknGN;EuBjnGM;IACI,WAAA;EvBmnGV;EuBjnGM;IACI,YAAA;EvBmnGV;EuBhnGE;IACI,4CAAA;IACA,wCAAA;IACA,yCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;EvBknGN;EuBhnGE;IACI,iCAAA;IACA,wCAAA;IACA,yCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;EvBknGN;EuB/mGE;IACI,UAAA;IACA,WAAA;EvBinGN;EuB9mGE;IACI,UAAA;IACA,WAAA;EvBgnGN;EuB3mGS;IACE,cAAA;EvB6mGX;EuBtmGU;IACI,YAAA;EvBwmGd;EuBtmGU;IACI,kBAAA;EvBwmGd;EuBtmGU;IACI,mBAAA;EvBwmGd;AACF;AuBnmGA,4CAAA;AAEA;EAEI;IACI,mBAAA;IACA,UAAA;IACA,kBAAA;IlBnCJ,8CAAA;IAxBA,0DAAA;ELwqGF;EuBvmGM;IACI,kBAAA;IACA,OAAA;IlB3CR,+CAAA;IAxBA,0DAAA;ELsrGF;EuB9mGM;IlBhDJ,6CAAA;IAxBA,0DAAA;ELksGF;EuBpnGE;IlBtDA,4CAAA;IAxBA,0DAAA;EL8sGF;EuB1nGE;IACI,6BAAA;EvB4nGN;EuBznGE;IACI,iDAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBAAA;EvB2nGN;EuBxnGU;IACI,2BAAA;IACA,WAAA;IACA,WAAA;IACA,ctBvHa;IsBwHb,aAAA;IACA,6BAAA;IACA,SAAA;IAEA,gBAAA;IlBxGZ,0DAAA;ELuuGF;EuB5nGc;IACI,yBAAA;IACA,kBAAA;IACA,ctBlIS;IsBmIT,aAAA;IACA,iBAAA;EvB8nGlB;EuB7nGkB;IACI,2CAAA;EvB+nGtB;EuBvnGc;IACI,gCAAA;EvBynGlB;EuBvnGc;IACI,kBAAA;EvBynGlB;EuBpnGE;IACI,WAAA;EvBsnGN;EuBnnGE;IACI,kBAAA;EvBqnGN;EuBnnGE;IACI,iBAAA;IACA,qCAAA;EvBqnGN;EuBnnGE;IACK,kBAAA;EvBqnGP;EuBnnGE;IACG,OAAA;IACA,uBAAA;EvBqnGL;EuBnnGE;IACI,UAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;EvBqnGN;EuBjnGM;IACI,WAAA;IACA,kBAAA;IACA,cAAA;EvBmnGV;EuB/mGE;IACI,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,QAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,UAAA;IlBjKA,mCAAA;IAhBJ,2DAAA;EL4yGF;EuBvnGM;IACI,kBAAA;IACA,UAAA;IACA,kBAAA;IACA,0BAAA;IACA,WAAA;EvBynGV;EuBtnGM;IACI,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,yBAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;EvBwnGV;EuBrnGM;IACI,kBAAA;IACA,UAAA;EvBunGV;EuBpnGM;IACI,kBAAA;EvBsnGV;EuBnnGE;IlBlMI,iCAAA;EL4zGN;EuBvnGE;IACI,YAAA;EvBynGN;EuBvnGE;IACI,OAAA;IlBzMA,oCAAA;ELu0GN;EuB3nGE;IACM,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;EvB6nGR;EuB1nGE;IACI,wBAAA;IACA,WAAA;IACA,YAAA;EvB4nGN;EuB1nGE;;;IAGE,8BAAA;EvB4nGJ;EuB1nGE;IACE,QAAA;IlBtJD,+BAAA;IAGA,6BAAA;ELqxGH;EuB/nGE;IACE,UAAA;EvBioGJ;EuB/nGE;IACE,WAAA;IlB7JD,kCAAA;IAGA,6BAAA;ELiyGH;EuBpoGE;IACE,QAAA;IlBjKD,4BAAA;IAGA,6BAAA;EL0yGH;EuBzoGE;IACE,UAAA;EvB2oGJ;EuBzoGE;IACE,WAAA;IlBxKD,+BAAA;IAGA,6BAAA;ELszGH;EKlzGE;IACE;MAAI,QAAA;MAAU,uBAAA;ILszGhB;IKrzGE;MAAK,QAAA;MAAU,yBAAA;ILyzGjB;IKxzGE;MAAK,yBAAA;IL2zGP;IK1zGE;MAAM,yBAAA;IL6zGR;EACF;EK7yGE;IACE;MAAK,QAAA;MAAU,yBAAA;ILi1GjB;IKh1GE;MAAM,yBAAA;ILm1GR;IKl1GE;MAAM,uBAAA;ILq1GR;IKp1GE;MAAO,QAAA;MAAU,oBAAA;ILw1GnB;EACF;EKt0GE;IACE;MAAI,WAAA;MAAa,uBAAA;IL02GnB;IKz2GE;MAAK,WAAA;MAAa,0BAAA;IL62GpB;IK52GE;MAAK,0BAAA;IL+2GP;IK92GE;MAAM,0BAAA;ILi3GR;EACF;EKj2GE;IACE;MAAK,WAAA;MAAY,0BAAA;ILq4GnB;IKp4GE;MAAM,wBAAA;ILu4GR;IKt4GE;MAAM,wBAAA;ILy4GR;IKx4GE;MAAO,WAAA;MAAY,oBAAA;IL44GrB;EACF;EuBhyGE;IACE;MAAI,UAAA;IvBm1GN;IuBl1GE;MAAM,UAAA;IvBq1GR;EACF;EuBn1GE;IACI,2CAAA;EvBq1GN;EuBl1GE;IACI,aAAA;EvBo1GN;EuBj1GU;IACI,4BAAA;EvBm1Gd;EuB70GM;;;;;;;;;;IAUI,YAAA;EvB+0GV;EuB50GM;;;IAGI,YAAA;IACA,6BAAA;IACA,aAAA;EvB80GV;EuB30GM;;IAEI,0CAAA;EvB60GV;EuBx0GM;IACI,UAAA;EvB00GV;EuBt0GU;IACI,yBAAA;IACA,sBAAA;EvBw0Gd;EuBt0GU;IACI,0BAAA;IACA,uBAAA;EvBw0Gd;EuBl0GE;IACI,aAAA;EvBo0GN;EuBl0GE;IACI,mCAAA;EvBo0GN;EuBl0GE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;EvBo0GN;EuBj0GE;IACI,kBtBzSuB;ED4mH7B;EuBj0GE;IACI,kBtB5SuB;ED+mH7B;EuBj0GE;IACI,WAAA;EvBm0GN;EuBj0GE;IACI,sBAAA;EvBm0GN;EuBj0GE;IACI,gBAAA;EvBm0GN;EuBj0GE;IACI,wCAAA;EvBm0GN;EuBj0GE;IACI,gBAAA;EvBm0GN;EuBj0GE;IACI,UAAA;IACA,sBAAA;IACA,cAAA;IACA,mBAAA;EvBm0GN;EuBj0GE;IACI,WAAA;EvBm0GN;EuBh0GE;IACI,cAAA;EvBk0GN;EuBh0GE;IACI,yBAAA;EvBk0GN;EuBh0GE;IACI,WAAA;EvBk0GN;EuBh0GE;IACI,gBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,SAAA;IAEA,gBAAA;EvBk0GN;EuB/zGM;IACI,4BAAA;IACA,SAAA;EvBi0GV;EuB9zGM;IACI,WAAA;IACA,eAAA;IACA,kBAAA;EvBg0GV;AACF;AuB1zGA;EACI;IACI,iBAAA;EvB4zGN;AACF;AuBxzGA;EACI;IACI,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,4CAAA;IACA,iCAAA;EvB0zGN;AACF;AwB/wHA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;AxBixHF;;AwB9wHA;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;AxBixHF;;AwB9wHA;;;EAKI,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,0BAAA;AxBixHJ;AwB/wHI;;;EACI,eAAA;EACA,iBAAA;AxBmxHR;;AwB/wHA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBvB5B2B;AD8yH7B;;AwB9wHA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kEAAA;AxBixHF;;AwB9wHA;EACE,8BAAA;EACA,2BAAA;AxBixHF;;AwB9wHA;EACE,gBAAA;AxBixHF;;AwB9wHA;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AxBixHF;;AwB7wHA;EAEE,4BAAA;AxBgxHF;;AwB5wHA;EACE,4BAAA;AxB+wHF;;AwB5wHA;EACE,6BAAA;AxB+wHF;;AwB5wHA;EACE,sBAAA;EACA,iBAAA;AxB+wHF;;AwB5wHA;EACE,sBAAA;EACA,6BAAA;AxB+wHF;;AyB74HA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,4SAAA;EACA,mBAAA;EACA,kBAAA;AzBg5HF;AyB94HA;;0BAAA;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;AzBg5HF;;AyB94HA;;0BAAA;AAGA;EACE,uBAAA;EACA,oBAAA;AzBi5HF;;AyB/4HA;EACE,cAAA;AzBk5HF;;AyBh5HA;EACE,cAAA;AzBm5HF;;AyBj5HA;;oCAAA;AAGA;;EAEE,qBAAA;EACA,oBAAA;EACA,sBAAA;AzBo5HF;;AyBl5HA;EACE,kBAAA;AzBq5HF;;AyBn5HA;;0BAAA;AAGA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;AzBs5HF;;AyBp5HA;EACE,kBAAA;AzBu5HF;;AyBr5HA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AzBw5HF;;AyBt5HA;EACE,MAAA;EACA,mBAAA;AzBy5HF;;AyBv5HA;;EAEE,kBAAA;EACA,kBAAA;AzB05HF;;AyBr5HQ;EACI,eAAA;AzBw5HZ;;AyBp5HA;;0BAAA;AAGA;EAGE,0CAAA;AzBu5HF;AyBr4HA;EACE;IAKE,uBAAA;EzBw5HF;EyBt5HA;IAKE,yBAAA;EzBw5HF;AACF;AyBt5HA;;0BAAA;AAGA;EACE,gEAAA;EAKA,wBAAA;AzBw5HF;;AyBt5HA;EACE,gEAAA;EAKA,yBAAA;AzBy5HF;;AyBv5HA;EACE,gEAAA;EAKA,yBAAA;AzB05HF;;AyBx5HA;EACE,gEAAA;EAKA,uBAAA;AzB25HF;;AyBz5HA;EACE,gEAAA;EAKA,uBAAA;AzB45HF;;AyB15HA;;0BAAA;AAIA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBz5HA;EACI,gBAAA;AzB45HJ;;AyBx5HA,oCAAA;AC5jBE;EACE,kBAAA;A1Bw9IJ;A0Bv9II;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A1By9IN;A0Bx9IM;EACE,gBAAA;A1B09IR;;A2Bl+II;EtB+EA,mBsB9E2B;EtBoF3B,8EAAA;EACA,0BAAA;ALu5IJ;A2B1+II;EACE,eAAA;EACA,gBAAA;A3B4+IN;;A2Bx+IA;EACE;IACE,kBAAA;IACA,aAAA;E3B2+IF;AACF;A2Bx+IA;EACE,kBAAA;A3B0+IF","sourcesContent":["/*!\n\n =========================================================\n * Light Bootstrap Dashboard React - v2.0.0\n =========================================================\n\n * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard-react\n * Copyright 2020 Creative Tim (http://www.creative-tim.com)\n * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n\n@import \"lbd/variables\";\n@import \"lbd/mixins\";\n\n@import \"lbd/typography\";\n\n// Core CSS\n@import \"lbd/misc\";\n@import \"lbd/sidebar-and-main-panel\";\n@import \"lbd/buttons\";\n@import \"lbd/inputs\";\n\n@import \"lbd/alerts\";\n@import \"lbd/tables\";\n\n@import \"lbd/checkbox-radio-switch\";\n@import \"lbd/navbars\";\n@import \"lbd/footers\";\n\n// Fancy Stuff\n@import \"lbd/plugins/animate\";\n@import \"lbd/dropdown\";\n@import \"lbd/cards\";\n@import \"lbd/chartist\";\n@import \"lbd/responsive\";\n@import \"lbd/bootstrap-switch\";\n\n// Nucleo Icons\n@import \"lbd/partial-nucleo-icons\";\n\n// React Differences\n@import \"lbdr/react-differences\";\n","//== Buttons\n//\n//## For each of Bootstrap's buttons, define text, background and border color.\n\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n\n$white-color:                #FFFFFF !default;\n$white-bg:                   #FFFFFF !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n\n$black-bg:                   rgba(30,30,30,.97) !default;\n\n$black-color:                #333333 !default;\n$black-hr:                   #444444 !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #DDDDDD !default;\n$medium-dark-gray:           #AAAAAA !default;\n$dark-gray:                  #9A9A9A !default;\n\n$transparent-bg:             transparent !default;\n\n$default-color:              #888888 !default;\n$default-bg:                 #888888 !default;\n$default-states-color:       #777777 !default;\n\n$primary-color:              #3472F7 !default;\n$primary-bg:                 #3472F7 !default;\n$primary-states-color:       #1D62F0 !default;\n\n$success-color:              #87CB16 !default;\n$success-bg:                 #87CB16 !default;\n$success-states-color:       #049F0C !default;\n\n$info-color:                 #1DC7EA !default;\n$info-bg:                    #1DC7EA !default;\n$info-states-color:          lighten($info-color, 8%) !default;\n\n$warning-color:              #FF9500 !default;\n$warning-bg:                 #FF9500 !default;\n$warning-states-color:       #ED8D00 !default;\n\n\n$danger-color:               #FF4A55 !default;\n$danger-bg:                  #FF4A55 !default;\n$danger-states-color:        #EE2D20 !default;\n\n\n\n$link-disabled-color:        #666666 !default;\n\n\n/*      light colors         */\n$light-blue:                 rgba($primary-color, .2);\n$light-azure:                rgba($info-color, .2);\n$light-green:                rgba($success-color, .2);\n$light-orange:               rgba($warning-color, .2);\n$light-red:                  rgba($danger-color, .2);\n\n\n//== Components\n//\n\n$padding-base-vertical:         8px !default;\n$padding-base-horizontal:      16px !default;\n\n$padding-round-vertical:        9px !default;\n$padding-round-horizontal:     18px !default;\n\n$padding-simple-vertical:      10px !default;\n$padding-simple-horizontal:    18px !default;\n\n$padding-large-vertical:       14px !default;\n$padding-large-horizontal:     30px !default;\n\n$padding-small-vertical:        5px !default;\n$padding-small-horizontal:     10px !default;\n\n$padding-xs-vertical:           1px !default;\n$padding-xs-horizontal:         5px !default;\n\n$padding-label-vertical:        2px !default;\n$padding-label-horizontal:     12px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n$padding-zero:                   0px !default;\n\n$margin-bottom:                0 0 10px 0 !default;\n$border-radius-small:           3px !default;\n$border-radius-base:            4px !default;\n$border-radius-large:           6px !default;\n$border-radius-extreme:        10px !default;\n\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\n\n$btn-round-radius:             30px !default;\n\n$height-base:                  40px !default;\n\n$font-size-base:               14px !default;\n$font-size-small:              12px !default;\n$font-size-medium:             16px !default;\n$font-size-large:              18px !default;\n$font-size-large-navbar:       20px !default;\n\n$font-size-h1:                 52px !default;\n$font-size-h2:                 36px !default;\n$font-size-h3:                 28px !default;\n$font-size-h4:                 22px !default;\n$font-size-h5:                 16px !default;\n$font-size-h6:                 14px !default;\n$font-paragraph:               16px !default;\n$font-size-navbar:             16px !default;\n$font-size-small:              12px !default;\n\n$font-weight-light:          300 !default;\n$font-weight-normal:         400 !default;\n$font-weight-semi:           500 !default;\n$font-weight-bold:           600 !default;\n\n$line-height-general:          1.5 !default;\n$line-height:                 20px !default;\n$line-height-lg:              54px !default;\n\n$sidebar-width:               calc(100% - 260px) !default;\n\n\n$border-radius-top:        10px 10px 0 0 !default;\n$border-radius-bottom:     0 0 10px 10px !default;\n\n$dropdown-shadow:          1px 2px 3px rgba(0, 0, 0, 0.125);\n\n$general-transition-time:  300ms !default;\n\n$slow-transition-time:           370ms !default;\n$dropdown-coordinates:      29px -50px !default;\n\n$fast-transition-time:           150ms !default;\n\n$ultra-fast-transition-time:     100ms  !default;\n\n$select-coordinates:         50% -40px !default;\n\n$transition-linear:                                   linear !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n$transition-ease-in:              ease-in !default;\n$transition-ease-out:             ease-out !default;\n\n\n$navbar-padding-a:               10px 15px;\n$navbar-margin-a:                10px  3px;\n\n$padding-social-a:               10px  5px;\n\n$navbar-margin-a-btn:            15px 3px;\n$navbar-margin-a-btn-round:      16px 3px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-brand:           15px 15px;\n$navbar-margin-brand:             5px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n\n$navbar-margin-btn:              15px  3px;\n\n$height-icon:\t\t\t\t\t 64px !default;\n$width-icon:\t\t\t\t\t 64px !default;\n$padding-icon:\t\t\t\t\t 12px !default;\n$border-radius-icon:\t\t     15px !default;\n\n$size-icon: \t\t\t\t\t 64px;\n$size-icon-sm: \t\t\t\t\t 32px;\n\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n$default-color-top:\t#d9d9d9 !default;\n$default-color-bottom: #909297 !default;\n\n$blue-color-top: \t\t            #4087ea;\n$blue-color-bottom: \t            #533ce1;\n\n$azure-color-top:   \t            #45c0fd;\n$azure-color-bottom:            \t#4091ff;\n\n$green-color-top: \t                #a1eb3a;\n$green-color-bottom: \t            #6dc030;\n\n$orange-color-top: \t                #ffb33b;\n$orange-color-bottom: \t            #ff5221;\n\n$red-color-top: \t                #ff3b30;\n$red-color-bottom: \t                #bb0502;\n\n$purple-color-top: \t                #df55e1;\n$purple-color-bottom: \t            #943bea;\n\n$pink-color-top: \t\t            #ff2a63;\n$pink-color-bottom: \t            #ff2e2e;\n\n$black-color-top:\t \t            #787878;\n$black-color-bottom: \t            #343434;\n\n$social-facebook: \t\t\t#3b5998;\n$social-twitter: \t\t\t#55acee;\n$social-pinterest: \t\t\t#cc2127;\n$social-google: \t\t\t#dd4b39;\n$social-linkedin: \t\t\t#0976b4;\n$social-dribbble: \t\t\t#ea4c89;\n$social-github: \t\t\t#333333;\n$social-youtube: \t\t\t#e52d27;\n$social-stumbleupon: \t\t#eb4924;\n$social-reddit: \t\t\t#ff4500;\n$social-tumblr: \t\t\t#35465c;\n$social-behance: \t\t\t#1769ff;\n\n\n$filter-blue:         darken($primary-color, 10%);\n$filter-azure:        darken($info-color, 10%);\n$filter-green:        darken($success-color, 10%);\n$filter-orange:       darken($warning-color, 10%);\n$filter-red:          darken($danger-color, 10%);\n\n\n$new-blue:            #1DC7EA;\n$new-purple:          #9368E9;\n$new-red:             #FB404B;\n$new-green:           #87CB16;\n$new-orange:          #FFA534;\n$new-dark-blue:       #1F77D0;\n$new-black:           #5e5e5e;\n\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n\n$white-navbar:              rgba(#FFFFFF, .96);\n$blue-navbar:               lighten($new-dark-blue, 10%);\n$azure-navbar:              lighten($new-blue, 15%);\n$green-navbar:              lighten($new-green, 10%);\n$orange-navbar:             lighten($new-orange, 10%);\n$red-navbar:                lighten($new-red, 10%);\n","$prefixes: ('', '-moz-', '-webkit-', '-ms-') !default;\n\n@mixin circle-animation(){\n   @for $i from 0 to length($prefixes) {\n        @include circle-animation-details(nth($prefixes, $i + 1));\n   }  \n}\n\n@mixin circle-animation-details($name){\n    #{$name}animation-name: spin;\n    #{$name}animation-duration: 1250ms;\n    #{$name}animation-iteration-count: infinite;\n    #{$name}animation-timing-function: linear;\n\n}\n@keyframes spin {\n    from { transform:rotate(0deg); }\n    to { transform:rotate(360deg); }\n}\n\n@-webkit-keyframes spin {\n    from { -webkit-transform: rotate(0deg); }\n    to { -webkit-transform: rotate(360deg); }\n}\n\n@-moz-keyframes spin {\n    from { -moz-transform: rotate(0deg); }\n    to { -moz-transform: rotate(360deg); }\n}\n\n@-ms-keyframes spin {\n    from { -ms-transform: rotate(0deg); }\n    to { -ms-transform: rotate(360deg); }\n}","/*           Font Smoothing      */\nbody,\nh1, .h1, \nh2, .h2, \nh3, .h3, \nh4, .h4, \nh5, .h5, \nh6, .h6, \np, \n.navbar, \n.brand, \n.btn-simple,\n.alert, \na, \n.td-name, \ntd,\nbutton.close{\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    font-family: \"Roboto\",\"Helvetica Neue\",Arial,sans-serif;\n    font-weight: $font-weight-normal;\n}\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4{\n    font-weight: $font-weight-light;\n    margin: $margin-large-vertical 0 $margin-base-vertical;\n}\n\nh1, .h1 {\n    font-size: $font-size-h1;\n}\nh2, .h2{\n    font-size: $font-size-h2;\n}\nh3, .h3{\n    font-size: $font-size-h3;\n    margin: 20px 0 10px;\n}\nh4, .h4{\n    font-size: $font-size-h4;\n    line-height: 30px;\n}\nh5, .h5 {\n    font-size: $font-size-h5;\n    margin-bottom: 15px;\n}\nh6, .h6{\n    font-size: $font-size-h6;\n    font-weight: $font-weight-bold;\n    text-transform: uppercase;\n}\np{\n    font-size: $font-paragraph;\n    line-height: $line-height-general;\n}\n\nh1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n    line-height: $line-height-general;\n}\n\nh1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {\n    font-size: 60%;\n}\n\nh1 .subtitle{\n    display: block;\n    margin: 0 0 $margin-large-vertical;   \n}\n\n.text-muted{\n    color: #9A9A9A;\n}\n.text-primary, .text-primary:hover{\n    color: #1D62F0 !important;\n}\n.text-info, .text-info:hover{\n    color: $info-color !important;\n}\n.text-success, .text-success:hover{\n    color: $success-color !important;\n}\n.text-warning, .text-warning:hover{\n    color: $warning-color !important;\n}\n.text-danger, .text-danger:hover{\n    color: $danger-color !important;\n}\n\n","/*     General overwrite     */\nbody,\n.wrapper{\n    min-height: 100vh;\n    position: relative;\n}\na{\n  color: $info-color;\n\n  &:hover, &:focus{\n     color: $info-states-color;\n     text-decoration: none;\n  }\n}\n\na:focus, a:active,\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner,\ninput[type=\"reset\"]::-moz-focus-inner,\ninput[type=\"button\"]::-moz-focus-inner,\ninput[type=\"submit\"]::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner{\n    outline:0;\n}\n.ui-slider-handle:focus,\n.navbar-toggle,\ninput:focus {\n    outline : 0 !important;\n}\n\n/*           Animations              */\n.form-control,\n.input-group-addon,\n.tagsinput,\n.navbar,\n.navbar .alert{\n    @include transition($general-transition-time, $transition-linear);\n}\n\n.sidebar .nav a,\n.table > tbody > tr .td-actions .btn{\n    @include transition($fast-transition-time, $transition-ease-in);\n}\n\n.btn{\n    @include transition($ultra-fast-transition-time, $transition-ease-in);\n}\n.fa,.fas,.far,.fal,.fad,.fab{\n    width: 18px;\n    text-align: center;\n}\n.margin-top{\n    margin-top: 50px;\n}\n\n.wrapper{\n    position: relative;\n    top: 0;\n    height: 100vh;\n}\n\n// documentation\n\n.page-header{\n    .page-header-image{\n        background-position: center center;\n        background-size: cover;\n        overflow: hidden;\n        width: 100%;\n        z-index: 1;\n    }\n    .title-container{\n        color: #fff;\n        position: relative;\n        top: 250px;\n        z-index: 3;\n    }\n    .filter:after{\n        background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #9368e9 0%, #943bea 100%) repeat scroll 0 0 / 150% 150%;\n        content: \"\";\n        display: block;\n        height: 100%;\n        left: 0;\n        opacity: 0.77;\n        position: absolute;\n        top: 0;\n        width: 100%;\n        z-index: 2;\n    }\n}\n\n.documentation .page-header,\n.documentation .page-header-image,\n.documentation .page-header-image .filter:after{\n    height: 100vh;\n}\n\n.documentation .footer{\n    z-index: 3;\n}\n.documentation .wrapper{\n    margin-top: -61px;\n    height: 100vh;\n}\n.documentation .navbar{\n    z-index: 21;\n}\n","// User select\n// For selecting text on the page\n\n@mixin user-select($select) {\n  -webkit-user-select: $select;\n     -moz-user-select: $select;\n      -ms-user-select: $select; // IE10+\n          user-select: $select;\n}\n\n@mixin box-shadow($shadow...) {\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\n          box-shadow: $shadow;\n}\n\n// Box sizing\n@mixin box-sizing($boxmodel) {\n  -webkit-box-sizing: $boxmodel;\n     -moz-box-sizing: $boxmodel;\n          box-sizing: $boxmodel;\n}\n\n\n@mixin transition($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n@mixin transform-scale($value){\n     -webkit-transform: scale($value);\n        -moz-transform: scale($value);\n        -o-transform: scale($value);\n        -ms-transform: scale($value);\n        transform: scale($value);\n}\n\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-3d($value){\n    -webkit-transform: translate3d($value, 0, 0);\n    -moz-transform: translate3d($value, 0, 0);\n    -o-transform: translate3d($value, 0, 0);\n    -ms-transform: translate3d($value, 0, 0);\n    transform: translate3d($value, 0, 0) !important;\n}\n\n@mixin transform-translate-y-dropdown($value){\n     -webkit-transform:  translate3d(0, $value, 0) !important;\n        -moz-transform: translate3d(0, $value, 0) !important;\n        -o-transform: translate3d(0, $value, 0) !important;\n        -ms-transform: translate3d(0, $value, 0) !important;\n        transform: translate3d(0, $value, 0) !important;\n}\n\n@mixin transform-translate-3d-0($value){\n    -webkit-transform: translate3d(0, $value, 0) !important;\n    -moz-transform: translate3d(0, $value, 0) !important;\n    -o-transform: translate3d(0, $value, 0) !important;\n    -ms-transform: translate3d(0, $value, 0) !important;\n    transform: translate3d(0, $value, 0) !important;\n}\n\n@mixin transform-origin($coordinates){\n      -webkit-transform-origin: $coordinates;\n        -moz-transform-origin: $coordinates;\n        -o-transform-origin: $coordinates;\n        -ms-transform-origin: $coordinates;\n        transform-origin: $coordinates;\n}\n\n@mixin icon-gradient ($top-color, $bottom-color){\n    background: $top-color;\n    background: -moz-linear-gradient(top,  $top-color 0%, $bottom-color 100%);\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,$top-color), color-stop(100%,$bottom-color));\n    background: -webkit-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: -o-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: -ms-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\n    background-size: 150% 150%;\n}\n\n@mixin radial-gradient($extern-color, $center-color){\n    background: $extern-color;\n    background: -moz-radial-gradient(center, ellipse cover, $center-color 0%, $extern-color 100%); /* FF3.6+ */\n    background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%,$center-color), color-stop(100%,$extern-color)); /* Chrome,Safari4+ */\n    background: -webkit-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* Opera 12+ */\n    background: -ms-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* IE10+ */\n    background: radial-gradient(ellipse at center, $center-color 0%,$extern-color 100%); /* W3C */\n    background-size: 550% 450%;\n}\n\n@mixin vertical-align {\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n",".sidebar,\nbody > .navbar-collapse{\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 260px;\n    display: block;\n    z-index: 1;\n    color: #fff;\n    font-weight: 200;\n    background-size: cover;\n    background-position: center center;\n\n    .sidebar-wrapper{\n        position: relative;\n        max-height: calc(100vh - 75px);\n        min-height: 100%;\n        overflow: auto;\n        width: 260px;\n        z-index: 4;\n        padding-bottom: 100px;\n    }\n\n    .sidebar-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n    }\n\n    .logo{\n        padding: 10px 15px 9px 15px;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n        position: relative;\n        z-index: 4;\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            color: $white-color;\n            line-height: 20px;\n            font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        }\n\n        .simple-text{\n            text-transform: uppercase;\n            padding: $padding-small-vertical $padding-zero;\n            display: block;\n            font-size: $font-size-large;\n            color: $white-color;\n            text-align: center;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n        }\n    }\n\n    .logo-tim{\n        border-radius: 50%;\n        border: 1px solid #333;\n        display: block;\n        height: 61px;\n        width: 61px;\n        float: left;\n        overflow: hidden;\n\n        img{\n            width: 60px;\n            height: 60px;\n        }\n    }\n\n    .nav{\n        margin-top: 20px;\n        float: none;\n        display: block;\n\n        li{\n            .nav-link{\n                color: $white-color;\n                margin: 5px 15px;\n                opacity: .86;\n                border-radius: 4px;\n                display: block;\n                padding: 10px 15px;\n\n                &:hover{\n                    background: rgba(255, 255, 255, 0.13);\n                    opacity: 1;\n                }\n\n                p{\n                    margin: 0;\n                    line-height: 31px;\n                    font-size: 12px;\n                    font-weight: 600;\n                    text-transform: uppercase;\n                    display: inline-flex;\n                }\n\n                i{\n                    font-size: 28px;\n                    margin-right: 15px;\n                    width: 30px;\n                    text-align: center;\n                    vertical-align: middle;\n                    float: left;\n                }\n            }\n\n            &:hover .nav-link{\n                background: rgba(255,255,255,0.13);\n                opacity: 1;\n            }\n\n            &.active .nav-link{\n                color: $white-color;\n                opacity: 1;\n                background: rgba(255,255,255,0.23);\n\n            }\n\n            &.separator{\n                margin: 15px 0;\n                border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n                & + .nav-item {\n                    margin-top: 31px;\n                }\n            }\n\n        }\n\n\n\n        .caret{\n            margin-top: 13px;\n            position: absolute;\n            right: 30px;\n        }\n\n        .active-pro{\n            position: absolute;\n            width: 100%;\n            bottom: 10px;\n\n            a{\n                color: $white-color !important;\n\n            }\n        }\n\n        .nav-link{\n            color: $white-color;\n            margin: 5px 15px;\n            opacity: .86;\n            border-radius: 4px;\n            text-transform: uppercase;\n            line-height: 30px;\n            font-size: 12px;\n            font-weight: 600;\n        }\n    }\n\n    .logo{\n        padding: $navbar-padding-a;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            color: $white-color;\n            line-height: 20px;\n            font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        }\n\n        .simple-text{\n            text-transform: uppercase;\n            padding: $padding-small-vertical $padding-zero;\n            display: block;\n            font-size: $font-size-large;\n            color: $white-color;\n            text-align: center;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n        }\n    }\n\n    .logo-tim{\n        border-radius: 50%;\n        border: 1px solid #333;\n        display: block;\n        height: 61px;\n        width: 61px;\n        float: left;\n        overflow: hidden;\n\n        img{\n            width: 60px;\n            height: 60px;\n        }\n    }\n\n    &:after,\n    &:before{\n        display: block;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 2;\n    }\n\n    &:before{\n        opacity: .33;\n        background: #000000;\n    }\n\n    &:after{\n       @include icon-gradient($new-purple, $purple-color-bottom);\n       z-index: 3;\n       opacity: 1;\n    }\n\n    &[data-image]:after,\n    &.has-image:after{\n        opacity: .77;\n    }\n\n    &[data-color=\"black\"]:after{\n        @include icon-gradient($default-states-color, $default-states-color);\n    }\n    &[data-color=\"blue\"]:after{\n        @include icon-gradient($new-dark-blue, $blue-color-bottom);\n    }\n    &[data-color=\"azure\"]:after{\n        @include icon-gradient($new-blue, $azure-color-bottom);\n    }\n    &[data-color=\"green\"]:after{\n        @include icon-gradient($new-green, $green-color-bottom);\n    }\n    &[data-color=\"orange\"]:after{\n        @include icon-gradient($new-orange, $orange-color-bottom);\n    }\n    &[data-color=\"red\"]:after{\n        @include icon-gradient($new-red, $red-color-bottom);\n    }\n    &[data-color=\"purple\"]:after{\n        @include icon-gradient($new-purple, $purple-color-bottom);\n    }\n}\n\n\n.main-panel{\n    background: rgba(203,203,210,.15);\n    position: relative;\n    float: right;\n    width: $sidebar-width;\n    min-height: 100%;\n\n    > .content{\n        padding: 30px 15px;\n        min-height: calc(100% - 123px);\n    }\n\n    > .footer{\n        border-top: 1px solid #e7e7e7;\n    }\n\n    .navbar{\n        margin-bottom: 0;\n    }\n}\n\n.sidebar,\n.main-panel{\n    overflow: auto;\n    max-height: 100%;\n    height: 100%;\n    -webkit-transition-property: top,bottom;\n    transition-property: top,bottom;\n    -webkit-transition-duration: .2s,.2s;\n    transition-duration: .2s,.2s;\n    -webkit-transition-timing-function: linear,linear;\n    transition-timing-function: linear,linear;\n    -webkit-overflow-scrolling: touch;\n}\n\n\n.fixed-plugin{\n\n    .dropdown{\n        .dropdown-menu{\n            @include transform-translate-3d-0(-5%);\n            border-radius: 10px;\n            li.adjustments-line{\n                border-bottom: 1px solid #ddd;\n            }\n            li{\n                padding: 5px 2px !important;\n            }\n            .button-container{\n                a{\n                    font-size: 14px;\n                }\n            &.show{\n                @include transform-translate-3d-0(0%);\n                transform-origin: 0 0;\n                left: -303px !important;\n            }\n            }\n\n        }\n    }\n\n}\n\n.fixed-plugin .dropdown .dropdown-menu{\n    @include transform-translate-y-dropdown(-5%);\n    top: -40px !important;\n    opacity: 0;\n    left: -303px !important;\n    transform-origin: 0 0;\n}\n.fixed-plugin .dropdown.show .dropdown-menu{\n    opacity: 1;\n    @include transform-translate-y-dropdown(0%);\n    transform-origin: 0 0;\n    left: -303px !important;\n}\n\n.fixed-plugin .dropdown-menu:before,\n.fixed-plugin .dropdown-menu:after{\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: 65px;\n    width: 16px;\n    transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    -moz-transform: translateY(-50%);\n\n}\n.fixed-plugin .dropdown-menu:before{\n    border-bottom: 16px solid rgba(0, 0, 0, 0);\n    border-left: 16px solid rgba(0,0,0,0.2);\n    border-top: 16px solid rgba(0,0,0,0);\n    right: -16px;\n}\n\n.fixed-plugin .dropdown-menu:after{\n    border-bottom: 16px solid rgba(0, 0, 0, 0);\n    border-left: 16px solid #fff;\n    border-top: 16px solid rgba(0,0,0,0);\n    right: -15px;\n}\n\n.modal{\n    &.show{\n        .modal-dialog{\n            -webkit-transform: translate(0, 30%);\n            -o-transform: translate(0, 30%);\n            transform: translate(0, 30%);\n        }\n    }\n    &.modal-mini{\n        .modal-dialog{\n            max-width: 255px;\n            margin: 0 auto;\n        }\n    }\n    .modal-content{\n        .modal-header{\n            border-bottom: none;\n            padding-top: 24px;\n            padding-right: 24px;\n            padding-bottom: 0;\n            padding-left: 24px;\n\n            .modal-profile{\n                width: 80px;\n                height: 80px;\n                border-radius: 50%;\n                text-align: center;\n                line-height: 5.7;\n                box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);\n\n                i{\n                    font-size: 32px;\n                    padding-top: 24px;\n                }\n            }\n        }\n\n        .modal-body{\n            padding-top: 24px;\n            padding-right: 24px;\n            padding-bottom: 16px;\n            padding-left: 24px;\n            line-height: 1.9;\n        }\n\n        .modal-body + .modal-footer{\n            padding-top: 0;\n        }\n\n        .modal-footer{\n            border-top: none;\n            padding-right: 24px;\n            padding-bottom: 16px;\n            padding-left: 24px;\n            -webkit-justify-content: space-between;\n            justify-content: space-between;\n\n            .btn{\n                margin: 0;\n                padding-left: 16px;\n                padding-right: 16px;\n                width: auto;\n\n                &:hover,\n                &focus{\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n}\n",".btn{\n    border-width: $border-thick;\n    background-color: $transparent-bg;\n    font-weight: $font-weight-normal;\n\n    @include opacity(.8);\n    padding: $padding-base-vertical $padding-base-horizontal;\n\n    @include btn-styles($default-color, $default-states-color);\n\n    &:hover,\n    &:focus{\n        @include opacity(1);\n        outline: 0 !important;\n        box-shadow: none;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n    &.btn-icon{\n        padding: $padding-base-vertical;\n    }\n\n}\n\n// Apply the mixin to the buttons\n//.btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary { @include btn-styles($primary-color, $primary-states-color); }\n.btn-success { @include btn-styles($success-color, $success-states-color); }\n.btn-info    { @include btn-styles($info-color, $info-states-color); }\n.btn-warning { @include btn-styles($warning-color, $warning-states-color); }\n.btn-danger  { @include btn-styles($danger-color, $danger-states-color); }\n.btn-neutral {\n    @include btn-styles($white-color, $white-color);\n\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n         background-color: $white-color;\n         color: $default-color;\n    }\n\n    &.btn-fill,\n    &.btn-fill:hover,\n    &.btn-fill:focus{\n        color: $default-color;\n    }\n\n    &.btn-simple:active,\n    &.btn-simple.active{\n        background-color: transparent;\n    }\n}\n\n.btn{\n     &:disabled,\n     &[disabled],\n     &.disabled{\n        @include opacity(.5);\n    }\n}\n.btn-round{\n    border-width: $border-thin;\n    border-radius: $btn-round-radius !important;\n    padding: $padding-round-vertical $padding-round-horizontal;\n\n    &.btn-icon{\n        padding: $padding-round-vertical;\n    }\n}\n.btn-simple{\n    border: $none;\n    font-size: $font-size-medium;\n    padding: $padding-base-vertical $padding-base-horizontal;\n\n    &.btn-icon{\n        padding: $padding-base-vertical;\n    }\n}\n.btn-lg{\n   @include btn-size($padding-large-vertical, $padding-large-horizontal, $font-size-large, $border-radius-large);\n   font-weight: $font-weight-normal;\n}\n.btn-sm{\n    @include btn-size($padding-small-vertical, $padding-small-horizontal, $font-size-small, $border-radius-small);\n}\n.btn-xs {\n    @include btn-size($padding-xs-vertical, $padding-xs-horizontal, $font-size-small, $border-radius-small);\n}\n.btn-wd {\n    min-width: 140px;\n}\n\n.btn-group.select{\n    width: 100%;\n}\n.btn-group.select .btn{\n    text-align: left;\n}\n.btn-group.select .caret{\n    position: absolute;\n    top: 50%;\n    margin-top: -1px;\n    right: 8px;\n}\n.btn-social{\n    opacity: 0.85;\n}\n\n.btn-twitter{\n    border-color: $social-twitter;\n    color: $social-twitter;\n    &:hover{\n        opacity: 1 !important;\n        border-color: $social-twitter;\n        color: $social-twitter;\n    }\n}\n.btn-facebook{\n    border-color: $social-facebook;\n    color: $social-facebook;\n\n    &:hover{\n        opacity: 1 !important;\n        border-color: $social-facebook;\n        color: $social-facebook;\n    }\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n\n@mixin black-filter($opacity){\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    background-color: rgba(17,17,17,$opacity);\n    display: block;\n    content: \"\";\n    z-index: 1; \n}","// Mixin for generating new styles\n@mixin btn-styles($btn-color, $btn-states-color) {\n  border-color: $btn-color;\n  color: $btn-color;\n  \n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    background-color: $transparent-bg;\n    color: $btn-states-color;\n    border-color: $btn-states-color;\n  }\n  \n  &.disabled,\n  &:disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: $transparent-bg;\n          border-color: $btn-color;\n    }\n  }\n  \n\n  &.btn-fill {\n    color: $white-color;\n    background-color: $btn-color;\n    @include opacity(1);  \n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n        background-color: $btn-states-color;\n        color: $white-color;\n    }\n    \n    .caret{\n        border-top-color: $white-color;\n    }\n  }\n  \n  .caret{\n      border-top-color: $btn-color;\n  }\n}\n\n\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n    \n   &.btn-round{\n       padding: $padding-vertical + 1 $padding-horizontal;\n   }\n   \n   &.btn-simple{\n       padding: $padding-vertical + 2 $padding-horizontal; \n   }\n    \n}",".form-control::-moz-placeholder{\n   @include placeholder($medium-gray,1);\n}\n.form-control:-moz-placeholder{\n   @include placeholder($medium-gray,1);\n}  \n.form-control::-webkit-input-placeholder{\n   @include placeholder($medium-gray,1); \n} \n.form-control:-ms-input-placeholder{\n   @include placeholder($medium-gray,1);\n}\n\n.form-control {\n    background-color: $white-bg;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n    color: #565656;\n    @include input-size($padding-base-vertical, $padding-base-horizontal - 4, $height-base);\n    @include box-shadow(none);\n    \n    &:focus{\n           background-color: $white-bg;\n           border: 1px solid $medium-dark-gray;\n           @include box-shadow(none);\n           outline: 0 !important;    \n           color: #333333;   \n    }\n    \n    .has-success &,\n    .has-error &,\n    .has-success &:focus,\n    .has-error &:focus{\n        border-color: $light-gray;\n        @include box-shadow(none);\n    }\n    \n    .has-success &{\n        color: $success-color;\n    }\n    .has-success &:focus{\n        border-color: $success-color;\n    }\n    .has-error &{\n        color: $danger-color;\n    }\n    .has-error &:focus{\n        border-color: $danger-color;\n    }\n    \n    & + .form-control-feedback{\n        border-radius: $border-radius-large;\n        font-size: $font-size-base;\n        margin-top: -7px;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        vertical-align: middle;\n    }\n    \n    .open &{\n        border-radius: $border-radius-base $border-radius-base 0 0;\n        border-bottom-color: transparent;\n    }\n}\n\n.input-lg{\n    height: 55px;\n    padding: $padding-large-vertical $padding-large-horizontal;\n}\n\n.has-error{\n    .form-control-feedback{\n        color: $danger-color;\n    }\n}\n.has-success{\n    .form-control-feedback{\n        color: $success-color\n    }\n}\n\n\n.input-group-addon {\n    background-color: $white-color;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n    \n    .has-success &,\n    .has-error &{\n        background-color: $white-color;\n        border: 1px solid $light-gray;\n    }\n    .has-error .form-control:focus + &{\n        border-color: $danger-color;\n        color: $danger-color;\n    }\n    .has-success .form-control:focus + &{\n        border-color: $success-color;\n        color: $success-color;\n    }\n    .form-control:focus + &,\n    .form-control:focus ~ &{\n        background-color: $white-color;\n        border-color: $dark-gray;\n    }\n}\n\n.input-group .form-control:first-child, \n.input-group-addon:first-child,  \n.input-group-btn:first-child > .dropdown-toggle, \n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child, \n.input-group-addon:last-child,  \n.input-group-btn:last-child > .dropdown-toggle, \n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $smoke-bg;\n    color: $default-color;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn{\n    border-width: $border-thin;\n    padding: $padding-round-vertical $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill){\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn{\n    margin-left: 0;\n}\n\n.input-group-focus .input-group-addon{\n    border-color: $dark-gray;\n}\n","@mixin input-size($padding-vertical, $padding-horizontal, $height){\n    padding: $padding-vertical $padding-horizontal;\n    height: $height;\n}\n\n@mixin placeholder($color, $opacity){\n   color: $color;\n   @include opacity(1);\n}\n\n@mixin light-form(){\n    border-radius: 0;\n    border:0;\n    padding: 0;\n    background-color: transparent;\n\n}",".alert{\n    border: 0;\n    border-radius: 0;\n    color: #FFFFFF;\n    padding: 10px 15px;\n    font-size: 14px;\n\n    .container &{\n        border-radius: 4px;\n\n    }\n    .navbar &{\n        border-radius: 0;\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 85px;\n        width: 100%;\n        z-index: 3;\n    }\n    .navbar:not(.navbar-transparent) &{\n        top: 70px;\n    }\n\n    span[data-notify=\"icon\"]{\n        font-size: 30px;\n        display: block;\n        left: 15px;\n        position: absolute;\n        top: 50%;\n        margin-top: -15px;\n    }\n\n    i.nc-simple-remove{\n        font-size: 12px !important;\n        font: bold normal normal 14px/1 'nucleo-icons';\n    }\n\n    button.close{\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        margin-top: -13px;\n        z-index: 1033;\n        background-color: #FFFFFF;\n        display: block;\n        border-radius: 50%;\n        opacity: .4;\n        line-height: 9px;\n        width: 25px;\n        height: 25px;\n        outline: 0 !important;\n        text-align: center;\n        padding: 3px;\n        font-weight: 300;\n\n        &:hover{\n            opacity: .55;\n        }\n    }\n\n    .close ~ span{\n        display: block;\n        max-width: 89%;\n    }\n\n    &[data-notify=\"container\"]{\n        padding: 10px 10px 10px 20px;\n        border-radius: $border-radius-base;\n    }\n\n    &.alert-with-icon{\n        padding-left: 65px;\n    }\n}\n.alert-primary{\n    background-color: $blue-navbar;\n}\n.alert-info{\n     background-color: $azure-navbar;\n}\n.alert-success {\n    background-color: $green-navbar;\n}\n.alert-warning {\n     background-color: $orange-navbar;\n}\n.alert-danger {\n     background-color: $red-navbar;\n}\n",".table{\n\n   .radio,\n   .checkbox{\n        position: relative;\n        height: 20px;\n        display: block;\n        width: 20px;\n        padding: 0px 0px;\n        margin: 0px 5px;\n        text-align: center;\n\n        .icons{\n            left: 5px;\n        }\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       padding: 12px 8px;\n       vertical-align: middle;\n   }\n\n    > thead > tr > th{\n        border-bottom-width: 1px;\n        font-size: $font-size-small;\n        text-transform: uppercase;\n        color: $dark-gray;\n        font-weight: $font-weight-normal;\n        padding-bottom: 5px;\n        border-top: none !important;\n        border-bottom: none;\n        text-align: left !important;\n    }\n\n   .td-actions .btn{\n        @include opacity(0.36);\n\n        &.btn-xs{\n            padding-left: 3px;\n            padding-right: 3px;\n        }\n    }\n    .td-actions{\n        min-width: 90px;\n    }\n\n    > tbody > tr{\n        position: relative;\n\n        &:hover{\n            .td-actions .btn{\n                @include opacity(1);\n            }\n        }\n    }\n\n    .btn:focus{\n        box-shadow: none !important;\n    }\n}\n.table-upgrade{\n    .table{\n        tr{\n            td{\n                width: 100%\n            }\n        }\n    }\n}\n\n.table .form-check .form-check-sign, .table .form-check .form-check-sign:after, .table .form-check .form-check-sign:before {\n    margin-top: -16px;\n}\n",".from-check,\n.form-check-radio {\n    margin-bottom: 12px;\n    position: relative;\n}\n\n.form-check{\n    .form-check-label{\n        display: inline-block;\n        position: relative;\n        cursor: pointer;\n        padding-left: 35px;\n        line-height: 26px;\n        margin-bottom: 0;\n        text-transform: capitalize;\n    }\n\n    .form-check-sign::before,\n    .form-check-sign::after{\n        font-family: \"Font Awesome 5 Free\";\n        content: \"\\f0c8\";\n        color: $default-color;\n        display: inline-block;\n        position: absolute;\n        width: 19px;\n        height: 19px;\n        margin-left: -23px;\n        font-size: 18px;\n        cursor: pointer;\n        transition: opacity 0.3s linear;\n    }\n    .form-check-sign::after{\n        font-family: \"Font Awesome 5 Free\";\n        content: \"\\f14a\";\n        text-align: center;\n        opacity: 0;\n        color: $info-color;\n        border: 0;\n        background-color: inherit;\n        margin-left: -23px;\n        font-weight: bold;\n    }\n    .form-check-sign::before{\n        margin-left: -22px;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n\n}\n\n#RegisterValidation .card{\n    .form-check{\n        .form-check-sign:before{\n            margin-left: -27px;\n        }\n    }\n}\n\n.form-check .form-check-input:disabled + .form-check-sign:before,\n.form-check .form-check-input:disabled + .form-check-sign:after,\n.radio input[type=\"radio\"]:disabled + label,\n.form-check .form-check-input:disabled:checked + .form-check-sign::after{\n    color: #ddd;\n    pointer-events: none\n}\n\n.form-check.disabled .form-check-label{\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"],\n.form-check-radio input[type=\"radio\"]{\n    opacity: 0;\n    position: absolute;\n    visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before{\n    opacity: 0;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check .form-check-label input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none !important;\n}\n\n.form-check.checkbox-inline{\n    display: inline-block;\n}\n\n\n.form-check-radio{\n    .form-check-label{\n        padding-left: 2.2rem;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $dark-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.form-check-radio .form-check-sign::before{\n    font-family: 'FontAwesome';\n    content: \"\\f10c\";\n    font-size: 18px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: inline-block;\n    position: absolute;\n    opacity: .50;\n    left: 34px;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n    transition: opacity 0.3s linear;\n    content:\" \";\n    display: block;\n    margin-left: 5px;\n    font-size: 18px;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    font-family: 'FontAwesome';\n    content: \"\\f192\";\n    position: absolute;\n    left: 5.3px;\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n    transition: opacity 0.3s linear;\n}\n\n.form-check input[type=\"radio\"]:checked + .form-check-sign::before{\n    opacity: 0;\n    transition: opacity 0.3s linear;\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n    color: $dark-gray;\n}\n\n.card{\n    &.stacked-form,\n    &.horizontal-form{\n        .form-check{\n            .form-check-label{\n                padding-left: 22px !important;\n            }\n        }\n    }\n}\n",".nav {\n    .nav-item{\n        .nav-link:hover,\n        .nav-link:focus{\n            background-color: transparent;\n        }\n    }\n\n}\n.navbar{\n    border: $none;\n    font-size: $font-size-navbar;\n    border-radius: 0;\n    min-height: 50px;\n    background-color: $white-navbar;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n    .navbar-brand {\n        font-weight: 400;\n        margin: 5px 0px;\n        font-size: 20px;\n        color: $default-color;\n\n        &:hover{\n            color: #5e5e5e;\n        }\n    }\n    .navbar-toggler{\n        vertical-align: middle;\n        outline: 0;\n        cursor: pointer;\n\n        &.navbar-toggler-left{\n            position: relative;\n            left: 0;\n            padding-left: 0;\n        }\n\n        &.navbar-toggler-right{\n            padding-right: 0;\n            top: 18px;\n        }\n\n        & .navbar-toggler-bar{\n            width: 3px;\n            height: 3px;\n            border-radius: 50%;\n            margin: 0 auto;\n        }\n        .burger-lines{\n            display: block;\n            position: relative;\n            background-color: #888;\n            width: 24px;\n            height: 2px;\n            border-radius: 1px;\n            margin: 4px auto;\n        }\n    }\n\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link{\n                color: $default-color;\n                padding: $navbar-padding-a;\n                margin: $navbar-margin-a;\n                position: relative;\n                display: inline-flex;\n                line-height: 40px;\n\n                &.btn{\n                    margin: $navbar-margin-a-btn;\n                    padding: $padding-base-vertical $padding-base-horizontal;\n                }\n\n                &.btn-round{\n                    margin: $navbar-margin-a-btn-round;\n                }\n\n                &[class^=\"fa\"],\n                &[class^=\"fas\"],\n                &[class^=\"far\"],\n                &[class^=\"fal\"],\n                &[class^=\"fad\"],\n                &[class^=\"fab\"]{\n                    font-size: $font-size-large + 1;\n                    position: relative;\n                    line-height: 40px;\n                    top: 1px;\n                }\n\n                &:hover{\n                    color: $info-color;\n                }\n            }\n\n            .dropdown-menu{\n                border-radius: $border-radius-extreme;\n                margin-top: -5px;\n\n                .dropdown-item{\n                    &:first-child{\n                        border-top-left-radius: 10px;\n                        border-top-right-radius: 10px;\n                    }\n                    &:last-child{\n                        border-bottom-left-radius: 10px;\n                        border-bottom-right-radius: 10px;\n                    }\n                }\n\n                .divider{\n                    height: 1px;\n                    margin: 5px 0;\n                    overflow: hidden;\n                    background-color: #e5e5e5;\n                }\n            }\n        }\n\n        .notification{\n            position: absolute;\n            background-color: #FB404B;\n            text-align: center;\n            border-radius: 10px;\n            min-width: 18px;\n            padding: 0 5px;\n            height: 18px;\n            font-size: 12px;\n            color: $white-color;\n            font-weight: bold;\n            line-height: 18px;\n            top: 10px;\n            left: 7px;\n        }\n\n        .dropdown-toggle:after{\n            display: inline-block;\n            width: 0;\n            height: 0;\n            margin-left: 5px;\n            margin-top: 20px;\n            vertical-align: middle;\n            border-top: 4px dashed;\n            border-top: 4px solid\\9;\n            border-right: 4px solid transparent;\n            border-left: 4px solid transparent;\n        }\n    }\n    .btn{\n       margin: $navbar-margin-btn;\n       font-size: $font-size-base;\n    }\n    .btn-simple{\n        font-size: $font-size-medium;\n    }\n\n    &.fixed{\n        width: calc(100% - #{$sidebar-width});\n        right: 0;\n        left: auto;\n        border-radius: 0;\n    }\n\n    .nc-icon{\n        font-weight: 700;\n        margin-top: 10px;\n    }\n}\n\n.navbar-transparent, [class*=\"navbar-ct\"]{\n    .navbar-brand{\n        color: $white-color;\n        @include opacity(.9);\n\n        &:focus,\n        &:hover{\n            background-color: transparent;\n            @include opacity(1);\n            color: $white-color;\n        }\n    }\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link:not(.btn){\n                color: $white-color;\n                border-color: $white-color;\n                @include opacity(0.8);\n            }\n        }\n\n        .active,\n        .nav-item{\n            .nav-link:not(.btn),\n            .nav-link:hover:not(.btn),\n            .nav-link:focus:not(.btn),{\n                background-color: transparent;\n                border-radius: 3px;\n                color: $white-color;\n                @include opacity(1);\n            }\n        }\n\n        .nav .nav-item .nav-link.btn:hover{\n            background-color: transparent;\n        }\n\n        .show{\n            .nav-link,\n            .nav-link:hover,\n            .nav-link:focus{\n                background-color: transparent;\n                color: $white-color;\n                @include opacity(1);\n            }\n        }\n    }\n\n    .btn-default{\n        color: $white-color;\n        border-color: $white-color;\n    }\n    .btn-default.btn-fill{\n        color: $dark-gray;\n        background-color: $white-color;\n        @include opacity(.9);\n    }\n    .btn-default.btn-fill:hover,\n    .btn-default.btn-fill:focus,\n    .btn-default.btn-fill:active,\n    .btn-default.btn-fill.active,\n    .show .dropdown-toggle.btn-fill.btn-default{\n        border-color: $white-color;\n        @include opacity(1);\n    }\n\n}\n.navbar-transparent{\n    .dropdown-menu .divider{\n        background-color: rgba($white-color,.2);\n    }\n}\n\n\n.navbar-default {\n    background-color: $white-navbar;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link:not(.btn){\n                color: $dark-gray;\n            }\n        }\n\n        .active .nav-link,\n        .active .nav-link:not(.btn):hover,\n        .active .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):focus{\n            background-color: transparent;\n            border-radius: 3px;\n            color: $info-color;\n            @include opacity(1);\n        }\n\n        .show{\n            .nav-link,\n            .nav-link:hover,\n            .nav-link:focus{\n                background-color: transparent;\n                color: $info-color;\n            }\n        }\n\n\n        .navbar-toggle:hover,.navbar-toggle:focus {\n            background-color: transparent;\n        }\n\n    }\n\n    &:not(.navbar-transparent) .btn-default:hover{\n        color: $info-color;\n        border-color: $info-color;\n    }\n    &:not(.navbar-transparent) .btn-neutral,\n    &:not(.navbar-transparent) .btn-neutral:hover,\n    &:not(.navbar-transparent) .btn-neutral:active{\n            color: $dark-gray;\n        }\n}\n\n/*      Navbar with icons            */\n\n.navbar-icons{\n    &.navbar .navbar-brand{\n        margin-top: 12px;\n        margin-bottom: 12px;\n    }\n    .navbar-nav{\n        .nav-item{\n            .nav-link{\n                text-align: center;\n                padding: $navbar-padding-a-icons;\n                margin: $navbar-margin-a-icons;\n            }\n        }\n\n        [class^=\"pe\"] {\n            font-size: 30px;\n            position: relative;\n        }\n        p {\n            margin: 3px 0 0;\n        }\n    }\n}\n\n.navbar-form{\n   @include box-shadow(none);\n   .form-control{\n        @include light-form();\n        height: 22px;\n        font-size: $font-size-navbar;\n        line-height: $line-height-general;\n        color: $light-gray;\n    }\n    .navbar-transparent & .form-control,\n    [class*=\"navbar-ct\"] & .form-control{\n        color: $white-color;\n        border: $none;\n        border-bottom: 1px solid rgba($white-color,.6);\n    }\n\n}\n\n.navbar-ct-blue{\n    @include navbar-color($blue-navbar);\n}\n.navbar-ct-azure{\n    @include navbar-color($azure-navbar);\n}\n.navbar-ct-green{\n    @include navbar-color($green-navbar);\n}\n.navbar-ct-orange{\n    @include navbar-color($orange-navbar);\n}\n.navbar-ct-red{\n    @include navbar-color($red-navbar);\n}\n\n.navbar-transparent{\n    padding-top: 15px;\n    background-color: transparent;\n    border-bottom: 1px solid transparent;\n}\n\n.navbar-toggle{\n    margin-top: 19px;\n    margin-bottom: 19px;\n    border: $none;\n\n    .icon-bar {\n        background-color: $white-color;\n    }\n     .navbar-collapse,\n     .navbar-form {\n        border-color: transparent;\n    }\n\n    &.navbar-default .navbar-toggle:hover,\n    &.navbar-default .navbar-toggle:focus {\n        background-color: transparent;\n    }\n}\n","@mixin navbar-color($color){\n    background-color: $color;\n}\n\n@mixin center-item(){\n    left: 0;\n    right: 0;\n    margin-right: auto;\n    margin-left: auto;\n    position: absolute;\n}",".footer{\n    background-color: $white-color;\n\n    .footer-menu{\n        height: 41px;\n    }\n\n    nav > ul{\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        font-weight: normal;\n\n        a:not(.btn){\n            color: $dark-gray;\n            display: block;\n            margin-bottom: 3px;\n            &:hover,\n            &:focus{\n                color: $default-states-color;\n            }\n        }\n    }\n    .social-area{\n        padding: 15px 0;\n        h5{\n            padding-bottom: 15px;\n        }\n    }\n    .social-area > a:not(.btn){\n       color: $dark-gray;\n       display: inline-block;\n       vertical-align: top;\n       padding: $padding-social-a;\n       font-size: $font-size-large-navbar;\n       font-weight: normal;\n       line-height: $line-height;\n       text-align: center;\n       &:hover,\n       &:focus{\n           color: $default-states-color;\n       }\n    }\n    .copyright{\n        color: $default-states-color;\n        padding: 10px 15px;\n        margin: 10px 3px;\n        line-height: 20px;\n        font-size: $font-size-base;\n    }\n    hr{\n        border-color: $medium-gray;\n    }\n    .title{\n        color: $default-states-color;\n    }\n}\n\n.footer-default{\n    background-color: $smoke-bg;\n}\n\n.footer:not(.footer-big){\n    nav > ul{\n       font-size: $font-size-base;\n       li{\n            margin-left: 20px;\n            float: left;\n        }\n        a{\n            padding: 10px 0px;\n            margin: 10px 10px 10px 0px;\n        }\n    }\n}\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// This file was modified by Creative Tim to keep only the animation that we need for Bootstrap Notify\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@charset \"UTF-8\";\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n@-webkit-keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n",".dropdown-menu{\n    visibility: hidden;\n    margin: 0;\n    padding: 0;\n    border-radius: $border-radius-extreme;\n    display: block;\n    z-index: 9000;\n    position: absolute;\n\n    @include opacity(0);\n    @include box-shadow($dropdown-shadow);\n\n    .show &{\n        @include opacity(1);\n        visibility: visible;\n    }\n    .select &{\n       border-radius: $border-radius-bottom;\n       @include box-shadow(none);\n       @include transform-origin($select-coordinates);\n       @include transform-scale(1);\n       @include transition($fast-transition-time, $transition-linear);\n       margin-top: -20px;\n    }\n    .select.show &{\n        margin-top: -1px;\n    }\n\n    .dropdown-item {\n       padding: $padding-base-vertical $padding-base-horizontal;\n       color: #333333;\n\n       img{\n           margin-top: -3px;\n       }\n    }\n    .dropdown-item:focus{\n        outline: 0 !important;\n    }\n\n    .btn-group.select &{\n        min-width: 100%;\n    }\n\n    > li:first-child > a{\n       border-top-left-radius: $border-radius-extreme;\n       border-top-right-radius: $border-radius-extreme;\n    }\n\n    > li:last-child > a{\n        border-bottom-left-radius: $border-radius-extreme;\n        border-bottom-right-radius: $border-radius-extreme;\n    }\n\n    .select & > li:first-child > a{\n        border-radius: 0;\n        border-bottom: 0 none;\n    }\n\n    .dropdown-item:hover,\n    .dropdown-item:focus {\n        background-color: $smoke-bg;\n        color: #333333;\n        opacity: 1;\n        text-decoration: none;\n    }\n\n    &.dropdown-blue > li > a:hover,\n    &.dropdown-blue > li > a:focus{\n        background-color: $light-blue;\n    }\n    &.dropdown-azure > li > a:hover,\n    &.dropdown-azure > li > a:focus{\n        background-color: $light-azure;\n    }\n    &.ct-green > li > a:hover,\n    &.ct-green > li > a:focus{\n        background-color: $light-green;\n    }\n    &.dropdown-orange > li > a:hover,\n    &.dropdown-orange > li > a:focus{\n        background-color: $light-orange;\n    }\n    &.dropdown-red > li > a:hover,\n    &.dropdown-red > li > a:focus{\n        background-color: $light-red;\n    }\n\n    .dropdown-item{\n        i[class*=\"nc-icon\"]{\n            font-size: 18px;\n            text-align: center;\n            line-height: 25px;\n            float: left;\n            padding-right: 10px;\n        }\n    }\n\n    &.dropdown-menu-right{\n        &:before,\n        &:after{\n            right: 12px !important;\n            left: auto !important;\n        }\n    }\n\n}\n\n.dropdown-with-icons{\n    > li > a{\n        padding-left: 0px;\n        line-height: 28px;\n    }\n    i{\n        text-align: center;\n        line-height: 28px;\n        float: left;\n\n        &[class^=\"pe-\"]{\n             font-size: 24px;\n             width: 46px;\n        }\n        &[class^=\"fa\"],\n        &[class^=\"fas\"],\n        &[class^=\"far\"],\n        &[class^=\"fal\"],\n        &[class^=\"fad\"],\n        &[class^=\"fab\"]\n        {\n            font-size: 14px;\n            width: 38px;\n        }\n    }\n}\n\n//fix bug for the select items in btn-group\n.btn-group.select{\n    overflow: hidden;\n}\n.btn-group.select.show{\n    overflow: visible;\n}\n",".card{\n    border-radius: $border-radius-base;\n    background-color: $white-color;\n    margin-bottom: 30px;\n\n    .card-image{\n        width: 100%;\n        overflow: hidden;\n        height: 260px;\n        border-radius: $border-radius-base $border-radius-base 0 0;\n        position: relative;\n        -webkit-transform-style: preserve-3d;\n        -moz-transform-style: preserve-3d;\n        transform-style: preserve-3d;\n\n        img {\n            width: 100%;\n        }\n    }\n    .filter{\n        position: absolute;\n        z-index: 2;\n        background-color: rgba(0,0,0,.68);\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        text-align: center;\n\n        @include opacity(0);\n\n        .btn{\n            @include vertical-align();\n        }\n    }\n    &:hover .filter{\n        @include opacity(1);\n    }\n    .btn-hover{\n        @include opacity(0);\n    }\n    &:hover .btn-hover{\n        @include opacity(1);\n    }\n    .card-body{\n        padding: 15px 15px 10px 15px;\n    }\n    .card-header{\n        padding: 15px 15px 0;\n        background-color: $white-color;\n        border-bottom: none !important;\n\n    }\n    .card-category,\n    label{\n        font-size: $font-size-base;\n        font-weight: $font-weight-normal;\n        color: $dark-gray;\n        margin-bottom: 0px;\n\n        i{\n            font-size: $font-paragraph;\n        }\n    }\n\n    label{\n        font-size: $font-size-small;\n        margin-bottom: 5px;\n        text-transform: uppercase;\n    }\n\n    .card-title{\n        margin: $none;\n        color: $black-color;\n        font-weight: $font-weight-light;\n    }\n    .avatar{\n        width: 30px;\n        height: 30px;\n        overflow: hidden;\n        border-radius: 50%;\n        margin-right: 5px;\n    }\n    .description{\n        font-size: $font-size-base;\n        color: #333;\n    }\n    .card-footer{\n        padding-top: 0;\n        background-color: $transparent-bg;\n        line-height: 30px;\n        border-top: none !important;\n        font-size: 14px;\n\n        .legend{\n            padding: 5px 0;\n        }\n\n        hr{\n            margin-top: 5px;\n            margin-bottom: 5px;\n        }\n    }\n    .stats{\n        color: #a9a9a9;\n    }\n    .card-footer div{\n        display: inline-block;\n    }\n\n    .author{\n        font-size: $font-size-small;\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n    }\n    .author i{\n        font-size: $font-size-base;\n    }\n    h6{\n        font-size: $font-size-small;\n        margin: 0;\n    }\n    &.card-separator:after{\n        height: 100%;\n        right: -15px;\n        top: 0;\n        width: 1px;\n        background-color: $medium-gray;\n        card-body: \"\";\n        position: absolute;\n    }\n\n    .ct-chart{\n        margin: 30px 0 30px;\n        height: 245px;\n    }\n\n    .ct-label{\n        font-size: 1rem !important;\n    }\n\n    .table{\n        tbody td:first-child,\n        thead th:first-child{\n            padding-left: 15px;\n        }\n\n        tbody td:last-child,\n        thead th:last-child{\n            padding-right: 15px;\n        }\n    }\n\n    .alert{\n        border-radius: $border-radius-base;\n        position: relative;\n\n        &.alert-with-icon{\n            padding-left: 65px;\n        }\n    }\n}\n\n\n\n.card-stats{\n    .card-body{\n        padding: 15px 15px 0px;\n\n        .numbers{\n            font-size: 1.8rem;\n            text-align: right;\n\n            p{\n                margin-bottom: 0;\n            }\n        }\n    }\n    .card-footer{\n        padding: 0px 15px 10px 15px;\n\n\n    }\n    .icon-big {\n        font-size: 3em;\n        min-height: 64px;\n\n        i{\n            font-weight: 700;\n            line-height: 59px;\n        }\n    }\n\n\n}\n\n.card-user{\n    .card-image{\n        height: 110px;\n    }\n    .card-image-plain{\n        height: 0;\n        margin-top: 110px;\n    }\n    .author{\n        text-align: center;\n        text-transform: none;\n        margin-top: -70px;\n    }\n    .avatar{\n        width: 124px;\n        height: 124px;\n        border: 5px solid #FFFFFF;\n        position: relative;\n        margin-bottom: 15px;\n\n        &.border-gray{\n            border-color: #EEEEEE;\n        }\n    }\n    .title{\n        line-height: 24px;\n    }\n    .card-body{\n        min-height: 240px;\n    }\n}\n\n.card-user,\n.card-price{\n    .card-footer{\n        padding: 5px 15px 10px;\n    }\n    hr{\n        margin: 5px 15px;\n    }\n}\n.card-plain{\n    background-color: transparent;\n    box-shadow: none;\n    border-radius: 0;\n\n    .card-image{\n        border-radius: 4px;\n    }\n}\n\n.card.card-plain{\n    border: none !important;\n\n    .card-header{\n        background-color: transparent !important;\n    }\n}\n","@mixin ct-responsive-svg-container($width: 100%, $ratio: $ct-container-ratio) {\n  display: block;\n  position: relative;\n  width: $width;\n\n  &:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: $ratio * 100%;\n  }\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n@mixin ct-align-justify($ct-text-align: $ct-text-align, $ct-text-justify: $ct-text-justify) {\n  -webkit-box-align: $ct-text-align;\n  -webkit-align-items: $ct-text-align;\n  -ms-flex-align: $ct-text-align;\n  align-items: $ct-text-align;\n  -webkit-box-pack: $ct-text-justify;\n  -webkit-justify-content: $ct-text-justify;\n  -ms-flex-pack: $ct-text-justify;\n  justify-content: $ct-text-justify;\n  // Fallback to text-align for non-flex browsers\n  @if($ct-text-justify == 'flex-start') {\n    text-align: left;\n  } @else if ($ct-text-justify == 'flex-end') {\n    text-align: right;\n  } @else {\n    text-align: center;\n  }\n}\n\n@mixin ct-flex() {\n  // Fallback to block\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin ct-chart-label($ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-text-line-height: $ct-text-line-height) {\n  fill: $ct-text-color;\n  color: $ct-text-color;\n  font-size: $ct-text-size;\n  line-height: $ct-text-line-height;\n}\n\n@mixin ct-chart-grid($ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray) {\n  stroke: $ct-grid-color;\n  stroke-width: $ct-grid-width;\n\n  @if ($ct-grid-dasharray) {\n    stroke-dasharray: $ct-grid-dasharray;\n  }\n}\n\n@mixin ct-chart-point($ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape) {\n  stroke-width: $ct-point-size;\n  stroke-linecap: $ct-point-shape;\n}\n\n@mixin ct-chart-line($ct-line-width: $ct-line-width, $ct-line-dasharray: $ct-line-dasharray) {\n  fill: none;\n  stroke-width: $ct-line-width;\n\n  @if ($ct-line-dasharray) {\n    stroke-dasharray: $ct-line-dasharray;\n  }\n}\n\n@mixin ct-chart-area($ct-area-opacity: $ct-area-opacity) {\n  stroke: none;\n  fill-opacity: $ct-area-opacity;\n}\n\n@mixin ct-chart-bar($ct-bar-width: $ct-bar-width) {\n  fill: none;\n  stroke-width: $ct-bar-width;\n}\n\n@mixin ct-chart-donut($ct-donut-width: $ct-donut-width) {\n  fill: none;\n  stroke-width: $ct-donut-width;\n}\n\n@mixin ct-chart-series-color($color) {\n  .#{$ct-class-point}, .#{$ct-class-line}, .#{$ct-class-bar}, .#{$ct-class-slice-donut} {\n    stroke: $color;\n  }\n\n  .#{$ct-class-slice-pie}, .#{$ct-class-area} {\n    fill: $color;\n  }\n}\n\n@mixin ct-chart($ct-container-ratio: $ct-container-ratio, $ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray, $ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape, $ct-line-width: $ct-line-width, $ct-bar-width: $ct-bar-width, $ct-donut-width: $ct-donut-width, $ct-series-names: $ct-series-names, $ct-series-colors: $ct-series-colors) {\n\n  .#{$ct-class-label} {\n    @include ct-chart-label($ct-text-color, $ct-text-size);\n  }\n\n  .#{$ct-class-chart-line} .#{$ct-class-label},\n  .#{$ct-class-chart-bar} .#{$ct-class-label} {\n    @include ct-flex();\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    //@include ct-chart-label($ct-text-color, $ct-text-size, center, $ct-vertical-text-justify);\n    @include ct-align-justify(center, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(center, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-grid} {\n    @include ct-chart-grid($ct-grid-color, $ct-grid-width, $ct-grid-dasharray);\n  }\n\n  .#{$ct-class-point} {\n    @include ct-chart-point($ct-point-size, $ct-point-shape);\n  }\n\n  .#{$ct-class-line} {\n    @include ct-chart-line($ct-line-width);\n  }\n\n  .#{$ct-class-area} {\n    @include ct-chart-area();\n  }\n\n  .#{$ct-class-bar} {\n    @include ct-chart-bar($ct-bar-width);\n  }\n\n  .#{$ct-class-slice-donut} {\n    @include ct-chart-donut($ct-donut-width);\n  }\n\n  @if $ct-include-colored-series {\n    @for $i from 0 to length($ct-series-names) {\n      .#{$ct-class-series}-#{nth($ct-series-names, $i + 1)} {\n        $color: nth($ct-series-colors, $i + 1);\n\n        @include ct-chart-series-color($color);\n      }\n    }\n  }\n}\n\n@if $ct-include-classes {\n  @include ct-chart();\n\n  @if $ct-include-alternative-responsive-containers {\n    @for $i from 0 to length($ct-scales-names) {\n      .#{nth($ct-scales-names, $i + 1)} {\n        @include ct-responsive-svg-container($ratio: nth($ct-scales, $i + 1));\n      }\n    }\n  }\n}","// Scales for responsive SVG containers\n$ct-scales: ((1), (15/16), (8/9), (5/6), (4/5), (3/4), (2/3), (5/8), (1/1.618), (3/5), (9/16), (8/15), (1/2), (2/5), (3/8), (1/3), (1/4)) !default;\n$ct-scales-names: (ct-square, ct-minor-second, ct-major-second, ct-minor-third, ct-major-third, ct-perfect-fourth, ct-perfect-fifth, ct-minor-sixth, ct-golden-section, ct-major-sixth, ct-minor-seventh, ct-major-seventh, ct-octave, ct-major-tenth, ct-major-eleventh, ct-major-twelfth, ct-double-octave) !default;\n\n// Class names to be used when generating CSS\n$ct-class-chart: ct-chart !default;\n$ct-class-chart-line: ct-chart-line !default;\n$ct-class-chart-bar: ct-chart-bar !default;\n$ct-class-horizontal-bars: ct-horizontal-bars !default;\n$ct-class-chart-pie: ct-chart-pie !default;\n$ct-class-chart-donut: ct-chart-donut !default;\n$ct-class-label: ct-label !default;\n$ct-class-series: ct-series !default;\n$ct-class-line: ct-line !default;\n$ct-class-point: ct-point !default;\n$ct-class-area: ct-area !default;\n$ct-class-bar: ct-bar !default;\n$ct-class-slice-pie: ct-slice-pie !default;\n$ct-class-slice-donut: ct-slice-donut !default;\n$ct-class-grid: ct-grid !default;\n$ct-class-vertical: ct-vertical !default;\n$ct-class-horizontal: ct-horizontal !default;\n$ct-class-start: ct-start !default;\n$ct-class-end: ct-end !default;\n\n// Container ratio\n$ct-container-ratio: (1/1.618) !default;\n\n// Text styles for labels\n$ct-text-color: rgba(0, 0, 0, 0.4) !default;\n$ct-text-size: 1.3rem !default;\n$ct-text-align: flex-start !default;\n$ct-text-justify: flex-start !default;\n$ct-text-line-height: 1;\n\n// Grid styles\n$ct-grid-color: rgba(0, 0, 0, 0.2) !default;\n$ct-grid-dasharray: 2px !default;\n$ct-grid-width: 1px !default;\n\n// Line chart properties\n$ct-line-width: 3px !default;\n$ct-line-dasharray: false !default;\n$ct-point-size: 8px !default;\n// Line chart point, can be either round or square\n$ct-point-shape: round !default;\n// Area fill transparency between 0 and 1\n$ct-area-opacity: 0.8 !default;\n\n// Bar chart bar width\n$ct-bar-width: 10px !default;\n\n// Donut width (If donut width is to big it can cause issues where the shape gets distorted)\n$ct-donut-width: 60px !default;\n\n// If set to true it will include the default classes and generate CSS output. If you're planning to use the mixins you\n// should set this property to false\n$ct-include-classes: true !default;\n\n// If this is set to true the CSS will contain colored series. You can extend or change the color with the\n// properties below\n$ct-include-colored-series: $ct-include-classes !default;\n\n// If set to true this will include all responsive container variations using the scales defined at the top of the script\n$ct-include-alternative-responsive-containers: $ct-include-classes !default;\n\n// Series names and colors. This can be extended or customized as desired. Just add more series and colors.\n$ct-series-names: (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o) !default;\n$ct-series-colors: (\n  $new-blue,\n  $new-red,\n  $new-orange,\n  $new-purple,\n  $new-green,\n  $new-dark-blue,\n  $new-black,\n  $social-google,\n  $social-tumblr,\n  $social-youtube,\n  $social-twitter,\n  $social-pinterest,\n  $social-behance,\n  #6188e2,\n  #a748ca\n) !default;\n","@media (min-width: 992px){\n    .navbar-form {\n        margin-top: 21px;\n        margin-bottom: 21px;\n        padding-left: 5px;\n        padding-right: 5px;\n    }\n    .navbar-nav .nav-item .dropdown-menu, .dropdown .dropdown-menu{\n        @include transform-scale(0);\n        @include transition($slow-transition-time, $transition-bezier);\n    }\n    .navbar-nav .nav-item.show .dropdown-menu, .dropdown.show .dropdown-menu{\n        @include transform-scale(1);\n        @include transform-origin($dropdown-coordinates);\n\n    }\n\n    .footer{\n        height: 60px;\n        .footer-menu{\n            float: left;\n        }\n        .copyright{\n            float: right;\n        }\n    }\n    .navbar-nav .nav-item .dropdown-menu:before{\n        border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        top: -11px;\n    }\n    .navbar-nav .nav-item .dropdown-menu:after {\n        border-bottom: 11px solid #FFFFFF;\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        top: -10px;\n    }\n\n    .navbar-nav.navbar-right .nav-item .dropdown-menu:before{\n        left: auto;\n        right: 12px;\n    }\n\n    .navbar-nav.navbar-right .nav-item .dropdown-menu:after{\n        left: auto;\n        right: 12px;\n    }\n\n    .footer:not(.footer-big){\n        nav > ul{\n           li:first-child{\n             margin-left: 0;\n           }\n        }\n    }\n\n    .card{\n        form{\n            [class*=\"col-\"]{\n                padding: 6px;\n            }\n            [class*=\"col-\"]:first-child{\n                padding-left: 15px;\n            }\n            [class*=\"col-\"]:last-child{\n                padding-right: 15px;\n            }\n        }\n    }\n}\n\n/*          Changes for small display      */\n\n@media (max-width: 991px){\n\n    .sidebar{\n        right: 0 !important;\n        left: auto;\n        position: absolute;\n        @include transform-translate-3d(262px);\n        @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .nav-open{\n        .main-panel{\n            position: absolute;\n            left: 0;\n            @include transform-translate-3d(-250px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n\n        .sidebar{\n            @include transform-translate-3d(10px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n    }\n\n    .main-panel{\n        @include transform-translate-3d(0px);\n        @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n\n    .nav-item.active-pro{\n        position: relative !important;\n    }\n\n    .nav-mobile-menu{\n        border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n        margin-bottom: 15px;\n        padding-bottom: 15px;\n        padding-top: 5px;\n\n        .dropdown{\n            .dropdown-menu{\n                position: static !important;\n                float: none;\n                width: auto;\n                color: $white-color;\n                margin-top: 0;\n                background-color: transparent;\n                border: 0;\n                -webkit-box-shadow: none;\n                box-shadow: none;\n                @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n                .dropdown-item{\n                    margin: 5px 15px 0px 40px;\n                    border-radius: 4px;\n                    color: $white-color;\n                    opacity: .86;\n                    padding: 8px 50px;\n                    &:hover{\n                        background-color: rgba(255, 255, 255, 0.23)\n                    }\n                }\n            }\n\n        }\n        .nav-item{\n            .nav-link{\n                span{\n                    display: inline-block !important;\n                }\n                .no-icon{\n                    padding-left: 50px;\n                }\n            }\n        }\n    }\n    .main-panel{\n        width: 100%;\n    }\n\n    .navbar-brand{\n        padding: 15px 15px;\n    }\n    .navbar-transparent{\n        padding-top: 15px;\n        background-color: rgba(0, 0, 0, 0.45);\n    }\n    body {\n         position: relative;\n    }\n    .wrapper{\n       left: 0;\n       background-color: white;\n    }\n    .navbar .container{\n        left: 15px;\n        width: 100%;\n        position: relative;\n        top: -10px;\n    }\n\n    .navbar-nav{\n        .nav-item{\n            float: none;\n            position: relative;\n            display: block;\n        }\n    }\n\n    body > .navbar-collapse {\n        position: fixed;\n        display: block;\n        top: 0;\n        height: 100%;\n        right: 0;\n        left: auto;\n        z-index: 1032;\n        visibility: visible;\n        background-color: #999;\n        overflow-y: visible;\n        border-top: none;\n        text-align: left;\n        padding: 0;\n\n        @include transform-translate-x(260px);\n        @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        > ul {\n            position: relative;\n            z-index: 4;\n            overflow-y:scroll;\n            height: calc(100vh - 61px);\n            width: 100%;\n        }\n\n        &::before{\n            top: 0;\n            left: 0;\n            height: 100%;\n            width: 100%;\n            position: absolute;\n            background-color: #282828;\n            display: block;\n            content: \"\";\n            z-index: 1;\n        }\n\n        .logo{\n            position: relative;\n            z-index: 4;\n        }\n\n        .nav li > a{\n            padding: 10px 15px;\n        }\n    }\n    .nav-show .navbar-collapse{\n        @include transform-translate-x(0px);\n    }\n    .nav-show .navbar .container{\n        left: -250px;\n    }\n    .nav-show .wrapper{\n        left: 0;\n        @include transform-translate-x(-260px);\n    }\n    .navbar-toggle .icon-bar {\n          display: block;\n          position: relative;\n          background: #fff;\n          width: 24px;\n          height: 2px;\n          border-radius: 1px;\n          margin: 0 auto;\n    }\n\n    .navbar-header .navbar-toggle {\n        margin: 10px 15px 10px 0;\n        width: 40px;\n        height: 40px;\n    }\n    .bar1,\n    .bar2,\n    .bar3 {\n      outline: 1px solid transparent;\n    }\n    .bar1 {\n      top: 0px;\n      @include bar-animation($topbar-back);\n    }\n    .bar2 {\n      opacity: 1;\n    }\n    .bar3 {\n      bottom: 0px;\n      @include bar-animation($bottombar-back);\n    }\n    .toggled .bar1 {\n      top: 6px;\n      @include bar-animation($topbar-x);\n    }\n    .toggled .bar2 {\n      opacity: 0;\n    }\n    .toggled .bar3 {\n      bottom: 6px;\n      @include bar-animation($bottombar-x);\n    }\n\n    @include topbar-x-rotation();\n    @include topbar-back-rotation();\n    @include bottombar-x-rotation();\n    @include bottombar-back-rotation();\n\n    @-webkit-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @-moz-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n\n    .dropdown-menu .divider{\n        background-color: rgba(229, 229, 229, 0.15);\n    }\n\n    .navbar-nav {\n        margin: 1px 0;\n\n        .show .dropdown-menu .nav-item{\n            .nav-link{\n                padding: 10px 15px 10px 60px;\n            }\n        }\n    }\n\n    [class*=\"navbar-\"] .navbar-nav {\n        & > li > a,\n        > li > a:hover,\n        > li > a:focus,\n        .active > a,\n        .active > a:hover,\n        .active > a:focus,\n        .show .dropdown-menu > li > a,\n        .show .dropdown-menu > li > a:hover,\n        .show .dropdown-menu > li > a:focus,\n        .show .dropdown-menu > li > a:active {\n            color: white;\n        }\n\n        & > li > a,\n        > li > a:hover,\n        > li > a:focus{\n            opacity: .7;\n            background-color: transparent;\n            outline: none;\n        }\n\n        .show .dropdown-menu > li > a:hover,\n        .show .dropdown-menu > li > a:focus{\n            background-color: rgba(255,255,255, .1);\n        }\n\n\n\n        &.navbar-nav .show .dropdown-menu > li > a:active {\n            opacity: 1;\n        }\n\n        & .dropdown > a{\n            &:hover .caret {\n                border-bottom-color: #fff;\n                border-top-color: #fff;\n            }\n            &:active .caret {\n                border-bottom-color: white;\n                border-top-color: white;\n            }\n        }\n\n    }\n\n    .dropdown-menu {\n        display: none;\n    }\n    .navbar-fixed-top {\n        -webkit-backface-visibility: hidden;\n    }\n    #bodyClick {\n        height: 100%;\n        width: 100%;\n        position: fixed;\n        opacity: 0;\n        top: 0;\n        left: auto;\n        right: 250px;\n        content: \"\";\n        z-index: 9999;\n        overflow-x: hidden;\n    }\n\n    .social-line .btn{\n        margin: $margin-bottom;\n    }\n    .subscribe-line .form-control{\n        margin: $margin-bottom;\n    }\n    .social-line.pull-right{\n        float: none;\n    }\n    .social-area.pull-right{\n        float: none !important;\n    }\n    .form-control + .form-control-feedback{\n        margin-top: -8px;\n    }\n    .navbar-toggle:hover,.navbar-toggle:focus {\n        background-color: transparent !important;\n    }\n    .btn.dropdown-toggle{\n        margin-bottom: 0;\n    }\n    .media-post .author{\n        width: 20%;\n        float: none !important;\n        display: block;\n        margin: 0 auto 10px;\n    }\n    .media-post .media-body{\n        width: 100%;\n    }\n\n    .navbar-collapse.collapse.in {\n        display: block;\n    }\n    .navbar-header .collapse, .navbar-toggle {\n        display:block !important;\n    }\n    .navbar-header {\n        float:none;\n    }\n    .navbar-nav .show .dropdown-menu {\n        position: static;\n        float: none;\n        width: auto;\n        margin-top: 0;\n        background-color: transparent;\n        border: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n    }\n    .navbar-collapse{\n        .navbar-nav p{\n            line-height: 40px !important;\n            margin: 0;\n        }\n\n        [class^=\"pe-7s-\"]{\n            float: left;\n            font-size: 20px;\n            margin-right: 10px;\n        }\n    }\n}\n\n//overwrite table responsive for 768px screens\n\n@media (min-width: 992px){\n    .table-responsive{\n        overflow: visible;\n    }\n\n}\n\n@media (max-width: 991px){\n    .table-responsive {\n        width: 100%;\n        margin-bottom: 15px;\n        overflow-x: scroll;\n        overflow-y: hidden;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n        -webkit-overflow-scrolling: touch;\n    }\n\n}\n",".bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  margin-bottom: 5px;\n  margin-left: 66px;\n  line-height: 8px;\n  width: 61px !important;\n  height: 26px;\n  outline: none;\n  z-index: 0;\n  margin-right: 1px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 26px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: inline-block !important;\n    height: 100%;\n    color: #fff;\n    padding: 6px 10px;\n    font-size: 11px;\n    text-indent: -5px;\n    line-height: 15px;\n    -webkit-transition: 0.25s ease-out;\n    transition: 0.25s ease-out;\n\n    i{\n        font-size: 12px;\n        line-height: 14px;\n  }\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  width: 50% !important;\n  background-color: $info-color;\n}\n\n\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 22px !important;\n  height: 22px;\n  margin: 2px -11px;\n  border-radius: 12px;\n  position: relative;\n  float: left;\n  padding: 0;\n  background-color: #FFFFFF;\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n\n.bootstrap-switch input[type='radio'],\n.bootstrap-switch input[type='checkbox'] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n  margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n  margin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px -13px -11px;\n}\n","/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: 'nucleo-icons';\n  src: url('~assets/fonts/nucleo-icons.eot');\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf') format('truetype'), url('~assets/fonts/nucleo-icons.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/*------------------------\n\tbase class definition\n-------------------------*/\n.nc-icon {\n  display: inline-block;\n  font: normal normal normal 14px/1 'nucleo-icons';\n  font-size: inherit;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n/*------------------------\n  change icon size\n-------------------------*/\n.nc-icon.lg {\n  font-size: 1.33333333em;\n  vertical-align: -16%;\n}\n.nc-icon.x2 {\n  font-size: 2em;\n}\n.nc-icon.x3 {\n  font-size: 3em;\n}\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.nc-icon.square,\n.nc-icon.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n.nc-icon.circle {\n  border-radius: 50%;\n}\n/*------------------------\n  list icons\n-------------------------*/\n.nc-icon-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.nc-icon-ul > li {\n  position: relative;\n}\n.nc-icon-ul > li > .nc-icon {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n.nc-icon-ul > li > .nc-icon.lg {\n  top: 0;\n  left: -1.35714286em;\n}\n.nc-icon-ul > li > .nc-icon.circle,\n.nc-icon-ul > li > .nc-icon.square {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n\n.all-icons{\n    .font-icon-list{\n        .font-icon-detail i{\n            font-size: 32px;\n        }\n    }\n}\n/*------------------------\n  spinning icons\n-------------------------*/\n.nc-icon.spin {\n  -webkit-animation: nc-icon-spin 2s infinite linear;\n  -moz-animation: nc-icon-spin 2s infinite linear;\n  animation: nc-icon-spin 2s infinite linear;\n}\n@-webkit-keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@-moz-keyframes nc-icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.nc-icon.rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.nc-icon.rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.nc-icon.rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.nc-icon.flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.nc-icon.flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n/*------------------------\n\tfont icons\n-------------------------*/\n\n.nc-air-baloon::before {\n    content: \"\\ea01\";\n}\n\n.nc-album-2::before {\n    content: \"\\ea02\";\n}\n\n.nc-alien-33::before {\n    content: \"\\ea03\";\n}\n\n.nc-align-center::before {\n    content: \"\\ea04\";\n}\n\n.nc-align-left-2::before {\n    content: \"\\ea05\";\n}\n\n.nc-ambulance::before {\n    content: \"\\ea06\";\n}\n\n.nc-android::before {\n    content: \"\\ea07\";\n}\n\n.nc-app::before {\n    content: \"\\ea08\";\n}\n\n.nc-apple::before {\n    content: \"\\ea09\";\n}\n\n.nc-atom::before {\n    content: \"\\ea0a\";\n}\n\n.nc-attach-87::before {\n    content: \"\\ea0b\";\n}\n\n.nc-audio-92::before {\n    content: \"\\ea0c\";\n}\n\n.nc-backpack::before {\n    content: \"\\ea0d\";\n}\n\n.nc-badge::before {\n    content: \"\\ea0e\";\n}\n\n.nc-bag::before {\n    content: \"\\ea0f\";\n}\n\n.nc-bank::before {\n    content: \"\\ea10\";\n}\n\n.nc-battery-81::before {\n    content: \"\\ea11\";\n}\n\n.nc-bell-55::before {\n    content: \"\\ea12\";\n}\n\n.nc-bold::before {\n    content: \"\\ea13\";\n}\n\n.nc-bulb-63::before {\n    content: \"\\ea14\";\n}\n\n.nc-bullet-list-67::before {\n    content: \"\\ea15\";\n}\n\n.nc-bus-front-12::before {\n    content: \"\\ea16\";\n}\n\n.nc-button-pause::before {\n    content: \"\\ea17\";\n}\n\n.nc-button-play::before {\n    content: \"\\ea18\";\n}\n\n.nc-button-power::before {\n    content: \"\\ea19\";\n}\n\n.nc-camera-20::before {\n    content: \"\\ea1a\";\n}\n\n.nc-caps-small::before {\n    content: \"\\ea1b\";\n}\n\n.nc-cart-simple::before {\n    content: \"\\ea1c\";\n}\n\n.nc-cctv::before {\n    content: \"\\ea1d\";\n}\n\n.nc-chart-bar-32::before {\n    content: \"\\ea1e\";\n}\n\n.nc-chart-pie-35::before {\n    content: \"\\ea1f\";\n}\n\n.nc-chart-pie-36::before {\n    content: \"\\ea20\";\n}\n\n.nc-chart::before {\n    content: \"\\ea21\";\n}\n\n.nc-chat-round::before {\n    content: \"\\ea22\";\n}\n\n.nc-check-2::before {\n    content: \"\\ea23\";\n}\n\n.nc-circle-09::before {\n    content: \"\\ea24\";\n}\n\n.nc-circle::before {\n    content: \"\\ea25\";\n}\n\n.nc-cloud-download-93::before {\n    content: \"\\ea26\";\n}\n\n.nc-cloud-upload-94::before {\n    content: \"\\ea27\";\n}\n\n.nc-compass-05::before {\n    content: \"\\ea28\";\n}\n\n.nc-controller-modern::before {\n    content: \"\\ea29\";\n}\n\n.nc-credit-card::before {\n    content: \"\\ea2a\";\n}\n\n.nc-delivery-fast::before {\n    content: \"\\ea2b\";\n}\n\n.nc-email-83::before {\n    content: \"\\ea2c\";\n}\n\n.nc-email-85::before {\n    content: \"\\ea2d\";\n}\n\n.nc-explore-2::before {\n    content: \"\\ea2e\";\n}\n\n.nc-fav-remove::before {\n    content: \"\\ea2f\";\n}\n\n.nc-favourite-28::before {\n    content: \"\\ea30\";\n}\n\n.nc-globe-2::before {\n    content: \"\\ea31\";\n}\n\n.nc-grid-45::before {\n    content: \"\\ea32\";\n}\n\n.nc-headphones-2::before {\n    content: \"\\ea33\";\n}\n\n.nc-html5::before {\n    content: \"\\ea34\";\n}\n\n.nc-istanbul::before {\n    content: \"\\ea35\";\n}\n\n.nc-key-25::before {\n    content: \"\\ea36\";\n}\n\n.nc-layers-3::before {\n    content: \"\\ea37\";\n}\n\n.nc-light-3::before {\n    content: \"\\ea38\";\n}\n\n.nc-lock-circle-open::before {\n    content: \"\\ea39\";\n}\n\n.nc-map-big::before {\n    content: \"\\ea3a\";\n}\n\n.nc-mobile::before {\n    content: \"\\ea3c\";\n}\n\n.nc-money-coins::before {\n    content: \"\\ea3b\";\n}\n\n.nc-note-03::before {\n    content: \"\\ea3d\";\n}\n\n.nc-notes::before {\n    content: \"\\ea3e\";\n}\n\n.nc-notification-70::before {\n    content: \"\\ea3f\";\n}\n\n.nc-palette::before {\n    content: \"\\ea40\";\n}\n\n.nc-paper-2::before {\n    content: \"\\ea41\";\n}\n\n.nc-pin-3::before {\n    content: \"\\ea42\";\n}\n\n.nc-planet::before {\n    content: \"\\ea43\";\n}\n\n.nc-preferences-circle-rotate::before {\n    content: \"\\ea44\";\n}\n\n.nc-puzzle-10::before {\n    content: \"\\ea45\";\n}\n\n.nc-quote::before {\n    content: \"\\ea46\";\n}\n\n.nc-refresh-02::before {\n    content: \"\\ea47\";\n}\n\n.nc-ruler-pencil::before {\n    content: \"\\ea48\";\n}\n\n.nc-satisfied::before {\n    content: \"\\ea49\";\n}\n\n.nc-scissors::before {\n    content: \"\\ea4a\";\n}\n\n.nc-send::before {\n    content: \"\\ea4b\";\n}\n\n.nc-settings-90::before {\n    content: \"\\ea4c\";\n}\n\n.nc-settings-gear-64::before {\n    content: \"\\ea4d\";\n}\n\n.nc-settings-tool-66::before {\n    content: \"\\ea4e\";\n}\n\n.nc-simple-add::before {\n    content: \"\\ea4f\";\n}\n\n.nc-simple-delete::before {\n    content: \"\\ea50\";\n}\n\n.nc-simple-remove::before {\n    content: \"\\ea51\";\n}\n\n.nc-single-02::before {\n    content: \"\\ea52\";\n}\n\n.nc-single-copy-04::before {\n    content: \"\\ea53\";\n}\n\n.nc-spaceship::before {\n    content: \"\\ea54\";\n}\n\n.nc-square-pin::before {\n    content: \"\\ea55\";\n}\n\n.nc-stre-down::before {\n    content: \"\\ea56\";\n}\n\n.nc-stre-left::before {\n    content: \"\\ea57\";\n}\n\n.nc-stre-right::before {\n    content: \"\\ea58\";\n}\n\n.nc-stre-up::before {\n    content: \"\\ea59\";\n}\n\n.nc-sun-fog-29::before {\n    content: \"\\ea5a\";\n}\n\n.nc-support-17::before {\n    content: \"\\ea5b\";\n}\n\n.nc-tablet-2::before {\n    content: \"\\ea5c\";\n}\n\n.nc-tag-content::before {\n    content: \"\\ea5d\";\n}\n\n.nc-tap-01::before {\n    content: \"\\ea5e\";\n}\n\n.nc-time-alarm::before {\n    content: \"\\ea5f\";\n}\n\n.nc-tv-2::before {\n    content: \"\\ea60\";\n}\n\n.nc-umbrella-13::before {\n    content: \"\\ea61\";\n}\n\n.nc-vector::before {\n    content: \"\\ea62\";\n}\n\n.nc-watch-time::before {\n    content: \"\\ea63\";\n}\n\n.nc-zoom-split::before {\n    content: \"\\ea64\";\n}\n\n\n/* all icon font classes list here */\n",".rna-container{\n  .alert {\n    border-radius: 4px;\n    button.close{\n      color: #000;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      span {\n        margin-top: -4px;\n      }\n    }\n  }\n}\n",".sidebar{\n    &[data-color=\"black\"]:after{\n        @include icon-gradient(#282828, rgba(#111,.7));\n    }\n    .logo-img img {\n      max-width: 40px;\n      max-height: 40px;\n    }\n}\n\n@media (max-width: 991px){\n  .sidebar .nav > li.active.active-pro {\n    position: relative;\n    bottom: unset;\n  }\n}\n\n#bodyClick {\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
